import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
} from "react";
import {
  ChevronRight,
  ChevronLeft,
  Pencil,
  NotebookPen,
  Trash,
  PencilLine,
} from "lucide-react";
import futImg from "../../../assets/DashIllustration.png";
import pandaImg from "../../../assets/StoryPanda.png";
import stars from "../../../assets/stars.png";
import emoji1 from "../../../assets/Emoji1.png";
import emoji2 from "../../../assets/Emoji2.png";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../UserContext";
import PopupModal from "./PopupModal";
import { useParams } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";

const fetchData = async () => {
  // const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

  return {
    mood: "Optimistic",
    futureId: {
      title: "Future Id",
      description:
        "Product design specialist turning bold ideas into scalable digital experiences.\n\nKnown for clarity, strategy, and sharp execution.",
      image: "https://i.imgur.com/1Q9Z1Zm.png",
    },
    incomplete: [],
    stake: {
      active: "Recoverable",
      options: {
        Recoverable: [],
        Critical: [],
      },
    },
    barriers: {
      active: "Internal",
      options: {
        External: [],
        Internal: [],
      },
    },
    blindSpots: [],
  };
};

const actionsTabs = ["Daily", "Weekly", "Monthly"];

const StoryDetails = () => {
  const { storyId } = useParams();
  const [data, setData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState("");
  const [isEditingFutureId, setIsEditingFutureId] = useState(false);

  const [futureIdData, setFutureIdData] = useState({
    title: "future ID",
    description: "future Discription",
  });

  const [tab, setTab] = useState("Unresolved");
  const [stakeData, setStakeData] = useState({
    Recoverable: [],
    Critical: [],
  });

  const [stakeTab, setStakeTab] = useState("Recoverable");

  const [barrierTab, setBarrierTab] = useState("Internal");
  const [activeTab, setActiveTab] = useState("Monthly");

  const [titleAndIdData, setTitleAndIdData] = useState("");
  const [showFloatingButton, setShowFloatingButton] = useState(false);
  const [threads, setThreads] = useState([]);
  const [incompleteThreads, setIncompleteThreads] = useState([]);
  const [unresolvedThreads, setUnresolvedThreads] = useState([]);
  const [unSpokenThreads, setUnSpokenThreads] = useState([]);
  const [assurenceAndDeepQuestion, setAssurenceAndDeepQuestion] = useState("");
  const [allBarriers, setAllBarriers] = useState({
    internal: [],
    external: [],
  });

  const [recentBarriers, setRecentBarriers] = useState({
    internal: [],
    external: [],
  });
  const [heroStory, setHeroStory] = useState("");
  const [isExpanded, setIsExpanded] = useState(false); // eslint-disable-line no-unused-vars
  const [blindSpots, setBlindSpots] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [modalTitle, setModalTitle] = useState("");
  const [modalType, setModalType] = useState("");

  const [selectedForStartReflection, setSelectedForStartReflection] =
    useState(null);
  const [newChapter, setNewChapter] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState("");

  const [activeBarrierIdx, setActiveBarrierIdx] = useState(null);
  const [activeStakeIdx, setActiveStakeIdx] = useState(null);

  const [actionsByFreq, setActionsByFreq] = useState({
    Daily: [],
    Weekly: [],
    Monthly: [],
  });
  // const [activeActionTab, setActiveActionTab] = useState("Daily");
  const [hasActions, setHasActions] = useState(false);

  // const cardWidth = 350; // consistent card width
  // const scrollOffset = cardWidth; // scroll one card at a time
  const scrollContainerRef = useRef(null);
  // const cardRef = useRef(null); // to measure real card width
  const [visibleCardCount, setVisibleCardCount] = useState(3); // responsive card count
  // Start with middle card highlighted
  const [currentCenterIndex, setCurrentCenterIndex] = useState(1); // eslint-disable-line no-unused-vars
  const totalOriginal = blindSpots.length; // eslint-disable-line no-unused-vars
  // const [cardWidth, setCardWidth] = useState(
  //   window.innerWidth < 768 ? 230 : 350
  // );
  const cardGap = 30;
  const [isScrolling, setIsScrolling] = useState(false); // eslint-disable-line no-unused-vars
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const triggerRef = useRef(null);
  const footerRef = useRef(null);

  const [currentIndex, setCurrentIndex] = useState(2);
  const [isAnimating, setIsAnimating] = useState(false);
  const [animationOffset, setAnimationOffset] = useState(0);
  const [cardWidth, setCardWidth] = useState(
    window.innerWidth < 768 ? 260 : 360
  );
  // const isMobile = window.innerWidth < 768;

  // const extendedBlindSpots = [
  //   ...blindSpots.slice(-2),
  //   ...blindSpots,
  //   ...blindSpots.slice(0, 2),
  // ];

  const extendedBlindSpots =
    blindSpots.length === 0
      ? []
      : blindSpots.length <= 3
      ? (() => {
          const repeated = [];
          const repeatCount = Math.ceil(15 / blindSpots.length);
          for (let i = 0; i < repeatCount * blindSpots.length; i++) {
            repeated.push(blindSpots[i % blindSpots.length]);
          }
          return repeated;
        })()
      : [...blindSpots.slice(-2), ...blindSpots, ...blindSpots.slice(0, 2)];

  useEffect(() => {
    const handleResize = () => {
      setCardWidth(window.innerWidth < 768 ? 260 : 360);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getVisibleCards = () => {
    const cards = [];
    for (let i = -2; i <= 2; i++) {
      const index =
        (currentIndex + i + extendedBlindSpots.length) %
        extendedBlindSpots.length;
      cards.push({ ...extendedBlindSpots[index], position: i, index });
    }
    return cards;
  };

  const goToPrevious = () => {
    if (isAnimating) return;
    setAnimationOffset(cardWidth);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentIndex(
        (prev) =>
          (prev - 1 + extendedBlindSpots.length) % extendedBlindSpots.length
      );
      setAnimationOffset(0);
      setIsAnimating(false);
    }, 400);
  };

  const goToNext = () => {
    if (isAnimating) return;
    setAnimationOffset(-cardWidth);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % extendedBlindSpots.length);
      setAnimationOffset(0);
      setIsAnimating(false);
    }, 400);
  };

  const scrollToIndex = useCallback(
    (index, smooth = true) => {
      if (!scrollContainerRef.current) return;
      const containerWidth = scrollContainerRef.current.offsetWidth;
      const scrollTo =
        index * (cardWidth + cardGap) - containerWidth / 2 + cardWidth / 2;

      scrollContainerRef.current.scrollTo({
        left: scrollTo,
        behavior: smooth ? "smooth" : "auto",
      });
    },
    [cardWidth, cardGap]
  );

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 768;
      setVisibleCardCount(isMobile ? 1 : 3);
      setCardWidth(isMobile ? 230 : 360);
      setCurrentCenterIndex(isMobile ? 1 : 2);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const startIndex = visibleCardCount === 1 ? 1 : 2;
    scrollToIndex(startIndex, false);
    setCurrentCenterIndex(startIndex);
  }, [visibleCardCount, cardWidth, scrollToIndex]);

  // const handleScroll = () => {
  //   if (!scrollContainerRef.current || isScrolling) return;
  //   const scrollLeftPos = scrollContainerRef.current.scrollLeft;
  //   const containerWidth = scrollContainerRef.current.clientWidth;
  //   const center = scrollLeftPos + containerWidth / 2;
  //   const totalCardSize = cardWidth + cardGap;
  //   const newIndex = Math.round(center / totalCardSize);
  //   const buffer = visibleCardCount === 1 ? 1 : 2;
  //   const maxIndex = totalOriginal + buffer;

  //   if (newIndex <= buffer - 1) {
  //     const jumpToIndex = totalOriginal + (newIndex - buffer + 1);
  //     setTimeout(() => {
  //       scrollToIndex(jumpToIndex, false);
  //       setCurrentCenterIndex(jumpToIndex);
  //     }, 100);
  //   } else if (newIndex >= maxIndex + 1) {
  //     const jumpToIndex = newIndex - totalOriginal;
  //     setTimeout(() => {
  //       scrollToIndex(jumpToIndex, false);
  //       setCurrentCenterIndex(jumpToIndex);
  //     }, 100);
  //   } else {
  //     setCurrentCenterIndex(newIndex);
  //   }
  // };

  // const scrollLeft = () => {
  //   if (isScrolling) return;
  //   setIsScrolling(true);
  //   let newIndex = currentCenterIndex - 1;
  //   scrollToIndex(newIndex);
  //   setTimeout(() => {
  //     const buffer = visibleCardCount === 1 ? 1 : 2;
  //     if (newIndex <= buffer - 1) {
  //       newIndex = totalOriginal + (newIndex - buffer + 1);
  //       scrollToIndex(newIndex, false);
  //     }
  //     setCurrentCenterIndex(newIndex);
  //     setIsScrolling(false);
  //   }, 400);
  // };

  // const scrollRight = () => {
  //   if (isScrolling) return;
  //   setIsScrolling(true);
  //   let newIndex = currentCenterIndex + 1;
  //   scrollToIndex(newIndex);
  //   setTimeout(() => {
  //     const buffer = visibleCardCount === 1 ? 1 : 2;
  //     const maxIndex = totalOriginal + buffer;
  //     if (newIndex >= maxIndex + 1) {
  //       newIndex = newIndex - totalOriginal;
  //       scrollToIndex(newIndex, false);
  //     }
  //     setCurrentCenterIndex(newIndex);
  //     setIsScrolling(false);
  //   }, 400);
  // };

  // Handle scroll to show/hide floating button
  useEffect(() => {
    const handleScroll = () => {
      if (!triggerRef.current || !footerRef.current) return;

      const triggerTop = triggerRef.current.offsetTop;
      const footerTop = footerRef.current.offsetTop;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // Show button when user scrolls past the trigger point
      // Hide button when user reaches the footer section
      const shouldShow =
        scrollY + windowHeight >= triggerTop &&
        scrollY + windowHeight <= footerTop + 100;

      setShowFloatingButton(shouldShow);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // get the title and summery , futureid
  useEffect(() => {
    const getStoryDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/identity`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch comments:", errorData.detail);
          return;
        }

        const data = await response.json();
        console.log("this is the title data", data);
        setTitleAndIdData(data.identity);
        setTitle(
          data.identity.selected_title ||
            data.identity.title?.[0]?.title ||
            "Untitled"
        );

        setFutureIdData({
          title: data.identity.emerging_identity_title,
          description: data.identity.emerging_identity?.[0] || "",
        });
      } catch (err) {
        console.error("Error fetching comments:", err);
      }
    };
    getStoryDetails();
  }, [storyId, user.user_id]);

  // get the openthreads
  useEffect(() => {
    const getSolutionNotAchieved = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/thread_if_solution_not_achieved`
        );

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch comments:", errorData.detail);
          return;
        }

        const data = await response.json();
        console.log("Raw unresolved threads data:", data);

        // ✅ First, access the nested array correctly
        const threadGroups =
          data.thread_if_not_achieved?.thread_if_not_achieved;

        if (!Array.isArray(threadGroups)) {
          console.error("Unexpected thread data structure:", threadGroups);
          return;
        }

        // ✅ Get the last thread group
        const lastGroup = threadGroups[threadGroups.length - 1];

        if (lastGroup && Array.isArray(lastGroup.threads)) {
          const latestThree = lastGroup.threads.slice(-3).map((thread) => ({
            observation: thread["Grounded Observation"] || "",
            contradiction:
              thread["Unfinished Thread / Contradiction"] ||
              thread.unfinished_thread ||
              "",
            punchline: thread["Introspective Punchline"] || "",
          }));

          console.log("Top 3 unresolved threads:", latestThree);
          setUnresolvedThreads(latestThree);
          setThreads(latestThree);
        }
      } catch (err) {
        console.error("Error fetching comments:", err);
      }
    };
    getSolutionNotAchieved();
  }, [storyId, user.user_id]);

  // getting the assurence staemnt and the deep questions
  useEffect(() => {
    const getAssurenceDetails = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/assurance_statement`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch comments:", errorData.detail);
          return;
        }

        const data = await response.json();

        const assurances = data.assurance_statement.assurance_statement;
        const questions = data.assurance_statement.very_deep_question;

        // Get last non-null assurance
        const lastAssuranceObj = [...assurances]
          .reverse()
          .find((item) => item !== null);
        const lastAssurance = lastAssuranceObj?.assurance_statement || "";

        // Get last non-null deep question
        const lastQuestionObj = [...questions]
          .reverse()
          .find((item) => item !== null);
        const lastQuestion = lastQuestionObj?.deep_question || "";

        setAssurenceAndDeepQuestion({
          assurance: lastAssurance,
          question: lastQuestion,
        });
      } catch (err) {
        console.error("Error fetching comments:", err);
      }
    };
    getAssurenceDetails();
  }, [storyId, user.user_id]);

  // get the stacks
  // useEffect(() => {
  //   const getStake = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/stake`
  //       );
  //       if (!response.ok) {
  //         const errorData = await response.json();
  //         console.error("Failed to fetch stake:", errorData.detail);
  //         return;
  //       }

  //       const result = await response.json();
  //       console.log("Raw Stake Data:", result);

  //       // Flatten and categorize the data
  //       const stakes = result.stake.stake.flatMap((item) => item.stakes);

  //       const recoverableAll = stakes
  //         .filter((s) => s.risk_level === "Repairable if acted on soon")
  //         .map((s) => `${s.stake}: ${s.implication}`);

  //       const criticalAll = stakes
  //         .filter((s) => s.risk_level === "At risk of permanent loss")
  //         .map((s) => `${s.stake}: ${s.implication}`);

  //       // Keep only latest 3 (assuming latest means last 3 items from the array)
  //       const recoverable = recoverableAll.slice(-3);
  //       const critical = criticalAll.slice(-3);

  //       setStakeData({
  //         Recoverable: recoverable,
  //         Critical: critical,
  //       });
  //     } catch (err) {
  //       console.error("Error fetching stake data:", err);
  //     }
  //   };

  //   getStake();
  // }, [assurenceAndDeepQuestion]);

  useEffect(() => {
    const getStake = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/stake`
        );

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch stake:", errorData.detail);
          return;
        }

        const result = await response.json();
        console.log("Raw Stake Data:", result);

        const rawStakeList = result?.stake?.stake ?? [];

        // Normalize all entries into a flat array of { stake, risk_level, implication }
        const normalized = rawStakeList.flatMap((entry) => {
          // Case 1: entry itself is a stake object
          if (entry?.stake && entry?.risk_level && entry?.implication) {
            return [
              {
                stake: entry.stake,
                risk_level: entry.risk_level,
                implication: entry.implication,
              },
            ];
          }

          // Case 2: entry contains "stakes" or "stake" array
          const nested = entry.stakes || entry.stake;
          if (Array.isArray(nested)) {
            return nested.map((item) => ({
              stake: item.stake || item.label || "Unknown",
              risk_level: item.risk_level || "Unknown",
              implication: item.implication || "",
            }));
          }

          return [];
        });

        const recoverable = normalized
          .filter((s) => s.risk_level === "Recoverable")

          .map((s) => `${s.stake}: ${s.implication}`)
          .slice(-3); // latest 3

        const critical = normalized
          .filter((s) => s.risk_level !== "Recoverable")

          .map((s) => `${s.stake}: ${s.implication}`)
          .slice(-3); // latest 3

        setStakeData({
          Recoverable: recoverable,
          Critical: critical,
        });
      } catch (err) {
        console.error("Error fetching stake data:", err);
      }
    };

    getStake();
  }, [storyId, user.user_id]);

  // get the barriers
  useEffect(() => {
    const getbarriers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/barrier`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch barriers:", errorData.detail);
          return;
        }

        const data = await response.json();

        console.log("barriers", data);
        const internalGroups = data?.barriers.internal_barrier;
        const externalGroups = data?.barriers.external_barrier;

        // Flatten internal barriers
        const allInternal = internalGroups
          .flatMap((group) => group.internal_barrier || [])
          .filter(
            (b) => b.label && !b.label.startsWith("None, explanation as:")
          );

        // Flatten external barriers
        // Updated: Flatten external barriers and filter out "None"
        const allExternal = externalGroups
          .flatMap((group) => group.external_barrier || [])
          .filter(
            (b) =>
              b.label &&
              b.label !== "None" &&
              !b.label.startsWith("None, explanation as:")
          );

        setAllBarriers({
          internal: allInternal,
          external: allExternal,
        });

        setRecentBarriers({
          internal: allInternal.slice(-3),
          external: allExternal.slice(-3),
        });
      } catch (err) {
        console.error("Error fetching barriers:", err);
      }
    };

    getbarriers();
  }, [storyId, user.user_id]);

  // getting the blind sports
  useEffect(() => {
    const getBlindSpots = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/blind_spots`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch blind spots:", errorData.detail);
          return;
        }

        const data = await response.json();

        // Flatten the nested blind_spots arrays
        const flattened = data.blind_spots.blind_spots
          .filter(Boolean)
          .flatMap((entry) => entry.blind_spots || []);

        setBlindSpots(flattened);
      } catch (err) {
        console.error("Error fetching blind spots:", err);
      }
    };

    getBlindSpots();
  }, [storyId, user.user_id]);

  // getting the prapose climex
  useEffect(() => {
    const getPraposeClimex = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/proposed_climax`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch proposed climax:", errorData.detail);
          return;
        }

        const data = await response.json();

        // Filter out nulls and use the first valid hero_story
        const validStories =
          data.proposed_climax.proposed_climax.filter(Boolean);
        if (validStories.length > 0) {
          const lastStory = validStories[validStories.length - 1];
          if (lastStory.hero_story) {
            setHeroStory(lastStory.hero_story);
          }
        }
      } catch (err) {
        console.error("Error fetching proposed climax:", err);
      }
    };

    getPraposeClimex();
  }, [storyId, user.user_id]);

  useEffect(() => {
    const getAcitons = async () => {
      try {
        // const response = await fetch(
        //   `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/6267ed35-1d67-4c7a-8bfd-aa284ab04b62/c71a1937-7d11-4ac5-bb01-18e5edd2f894/actions`
        // );
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/actions`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch proposed climax:", errorData.detail);
          return;
        }

        const data = await response.json();

        console.log("action", data);

        const rawActions = data.session_actions?.flatMap((session) =>
          Object.values(session.actions || {})
        );

        if (rawActions.length === 0) {
          setHasActions(false);
          setActionsByFreq({ Daily: [], Weekly: [], Monthly: [] });
          return;
        }

        // Group by frequency
        const grouped = { Daily: [], Weekly: [], Monthly: [] };
        rawActions.forEach((action) => {
          const freq = action.frequency;
          if (grouped[freq]) {
            grouped[freq].push(action);
          }
        });

        setActionsByFreq(grouped);
        setHasActions(true);
      } catch (err) {
        console.error("Error fetching proposed climax:", err);
      }
    };

    getAcitons();
  }, [storyId, user.user_id]);

  // get the other threads on click

  const getThreadsBasedOnTab = useCallback(
    async (tab) => {
      setThreads([]);

      if (tab === "Unresolved" && unresolvedThreads.length > 0) {
        setThreads(unresolvedThreads);
        return;
      }

      if (tab === "Unspoken" && unSpokenThreads.length > 0) {
        setThreads(unSpokenThreads);
        return;
      }

      if (tab === "Incomplete" && incompleteThreads.length > 0) {
        setThreads(incompleteThreads);
        return;
      }

      try {
        let response = "";
        if (tab === "Incomplete") {
          response = await fetch(
            `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/open_threads`
          );
          if (!response.ok) {
            const errorData = await response.json();
            console.error("Failed to fetch comments:", errorData.detail);
            return;
          }

          const data = await response.json();
          console.log("this is open threads data", data);

          // Get the last open_thread
          const openThreadsArray = data.open_threads.open_threads;
          const lastThreadGroup = openThreadsArray[openThreadsArray.length - 1];

          if (lastThreadGroup && Array.isArray(lastThreadGroup.threads)) {
            // Get the last 3 threads
            const latestThree = lastThreadGroup.threads.slice(-3);

            const valuesArray = latestThree.map((thread) => ({
              observation: thread["Grounded Observation"] || "",
              contradiction:
                thread["Unfinished Thread / Contradiction"] ||
                thread.unfinished_thread ||
                "",
              punchline: thread["Introspective Punchline"] || "",
            }));

            console.log("this is openthred need to be displayed", valuesArray);

            setIncompleteThreads(valuesArray);
            setThreads(valuesArray);
          }
        } else if (tab === "Unspoken") {
          response = await fetch(
            `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/thread_if_solution_not_clear`
          );

          if (!response.ok) {
            const errorData = await response.json();
            console.error("Failed to fetch comments:", errorData.detail);
            return;
          }

          const data = await response.json();
          console.log("Raw not-clear threads data:", data);

          // ✅ Correctly access the nested thread array
          const notClearThreadsArray =
            data.thread_if_not_clear?.thread_if_not_clear;

          if (!Array.isArray(notClearThreadsArray)) {
            console.error(
              "Unexpected structure in not-clear threads:",
              notClearThreadsArray
            );
            return;
          }

          // ✅ Get the last group of threads
          const lastThreadGroup =
            notClearThreadsArray[notClearThreadsArray.length - 1];

          if (lastThreadGroup && Array.isArray(lastThreadGroup.threads)) {
            const lastThreeUnfinished = lastThreadGroup.threads
              .slice(-3)
              .map((thread) => ({
                observation: thread["Grounded Observation"] || "",
                contradiction:
                  thread["Unfinished Thread / Contradiction"] ||
                  thread.unfinished_thread ||
                  "",
                punchline: thread["Introspective Punchline"] || "",
              }));

            console.log("Last 3 unfinished (not clear):", lastThreeUnfinished);
            setUnSpokenThreads(lastThreeUnfinished);
            setThreads(lastThreeUnfinished);
          }
        }
      } catch (err) {
        console.error("Error fetching comments:", err);
      }
    },
    [
      incompleteThreads,
      storyId,
      unSpokenThreads,
      unresolvedThreads,
      user.user_id,
    ]
  );

  useEffect(() => {
    const load = async () => {
      const d = await fetchData();

      d.barriers = {
        ...d.barriers,
        options: {
          Internal: recentBarriers.internal.map((b) => b.label),
          External: recentBarriers.external.map((b) => b.label),
        },
        active: d.barriers?.active || "Internal",
      };

      setData(d);
      setStakeTab(d.stake?.active || "");
      setBarrierTab(d.barriers.active);
      console.log("these are some barriers", d.barriers);
    };

    if (recentBarriers.internal.length || recentBarriers.external.length) {
      load();
    }
  }, [recentBarriers]);

  const getPreview = (text, wordLimit = 50) => {
    const words = text.split(" ");
    return words.length <= wordLimit
      ? text
      : words.slice(0, wordLimit).join(" ") + "...";
  };

  const handleOpenModal = (title, data, type) => {
    setModalTitle(title);
    setModalData(data);
    setModalType(type); // 'blind_spots', 'barriers', etc.
    setIsModalOpen(true);
  };

  // const handleNewChapter = (storyId) => {
  //   setIsLoading(true);

  //   console.log(selectedForStartReflection);
  //   endAllRunningSessions();
  // };

  const addFirstResponse = useCallback(
    async (sessionID) => {
      setIsLoadingData("Adding your first step");
      const payload = {
        coachee_response: selectedForStartReflection,
        focus_popup_required: 0,
        record_from_focus_popup: 0,
        selected_focus_choice: 1,
        conversation_summary: "",
        regenerate_with_intention: false,
        focus_options: "",
        alternate_focus_hypothesis: "",
      };
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/${sessionID}/step`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const data = await response.json();
        console.log("This is the data", data);
        if (response.ok) {
          navigate("/chat");
          console.log(storyId, "story id is from start new chapter");
        }
      } catch (error) {
        console.error("Error creating session:", error);
      }
    },
    [
      selectedForStartReflection,
      user.user_id,
      storyId,
      navigate,
      setIsLoadingData,
    ]
  );

  // createSession function
  const createSession = useCallback(
    async (coach) => {
      // const currentMood = "NO mood selecter for this chapter";
      setIsLoadingData("Your new chapter is being created");
      console.log("THIS IS NEW CHAPTER VALUE", newChapter);
      try {
        const queryParam = `?newChapter=${(!newChapter).toString()}`;
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/create/${coach.coachName}/${coach.selectedTime}/Sad/${storyId}${queryParam}`,
          {
            method: "GET",
          }
        );
        console.log("Called continue session API with story_id:", storyId);

        if (!res.ok) {
          throw new Error("Failed to create session");
        }

        const createSession = await res.json();
        console.log(createSession);
        if (newChapter) {
          navigate("/chat");
          console.log(storyId, "story id is from start new chapter");
        } else {
          addFirstResponse(createSession.session_id);
        }

        // addFirstResponse(createSession.session_id);

        console.log("sessio will be created in a min");
      } catch (error) {
        console.error("Error creating session:", error);
      }
    },
    [
      user.user_id,
      newChapter,
      storyId,
      navigate,
      addFirstResponse,
      setIsLoadingData,
    ]
  );

  //createSession to dependency array
  const endAllRunningSessions = useCallback(async () => {
    setIsLoadingData("All running conversations are being closed");
    const coach = { coachName: "Eira", selectedTime: 21 };
    try {
      await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/end`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // const exitSession = await res.json();
      // console.log(exitSession);
      console.log("Session Ended");
      createSession(coach);
    } catch (error) {
      console.log("The session has ended:", error.message);
    }
  }, [user.user_id, createSession]);

  const handleNewChapter = useCallback(() => {
    setIsLoading(true);
    endAllRunningSessions();
  }, [endAllRunningSessions]);

  useEffect(() => {
    if (!selectedForStartReflection) return;
    console.log("this has to be the updated value", selectedForStartReflection);
    handleNewChapter(); // selectedForStartReflection is now available
  }, [selectedForStartReflection, handleNewChapter]);

  // const handleSelect = (item) => {
  //   console.log(item);
  //   setSelectedForStartReflection(item);
  //   handleNewChapter(item);
  // };

  useEffect(() => {
    if (newChapter) {
      handleNewChapter();
    }
  }, [newChapter, handleNewChapter]);

  // const createSession = useCallback(async (coach) => {
  //   // const currentMood = "NO mood selecter for this chapter";
  //   setIsLoadingData("Your new chapter is being created");
  //   console.log("THIS IS NEW CHAPTER VALUE", newChapter);
  //   try {
  //     const queryParam = `?newChapter=${(!newChapter).toString()}`;
  //     const res = await fetch(
  //       `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/create/${coach.coachName}/${coach.selectedTime}/Sad/${storyId}${queryParam}`,
  //       {
  //         method: "GET",
  //       }
  //     );
  //     console.log("Called continue session API with story_id:", storyId);

  //     if (!res.ok) {
  //       throw new Error("Failed to create session");
  //     }

  //     const createSession = await res.json();
  //     console.log(createSession);
  //     if (newChapter) {
  //       navigate("/chat");
  //       console.log(storyId, "story id is from start new chapter");
  //     } else {
  //       addFirstResponse(createSession.session_id);
  //     }

  //     // addFirstResponse(createSession.session_id);

  //     console.log("sessio will be created in a min");
  //   } catch (error) {
  //     console.error("Error creating session:", error);
  //   }
  // }, [user.user_id, newChapter, storyId, navigate]);

  // const handleSelect = (item) => {
  //   setSelectedForStartReflection(item);
  // };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSave = async () => {
    setIsEditing(false);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_selected_title`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userid: user.user_id,
            story_id: storyId,
            chapter_id: titleAndIdData.chapter_id, // make sure this exists in your state
            title: title,
          }),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Failed to update title:", errorData.detail || errorData);
        return;
      }

      const result = await response.json();
      console.log("Title updated successfully:", result);
    } catch (error) {
      console.error("Error updating title:", error);
    }
  };

  const handleFutureIdSave = async () => {
    setIsEditingFutureId(false);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_future_id`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userid: user.user_id,
            story_id: storyId,
            future_identity: futureIdData.description,
            future_identity_title: futureIdData.title,
          }),
        }
      );

      if (!res.ok) throw new Error("Failed to update Future ID");

      const data = await res.json();
      console.log("Future ID updated:", data);
    } catch (error) {
      console.error("Error updating Future ID:", error);
    }
  };

  const isNoExternalBarrier =
    barrierTab === "External" &&
    (data?.barriers.options[barrierTab].length === 0 ||
      data?.barriers.options[barrierTab][0] ===
        "No external barrier is present");

  // if (!assurenceAndDeepQuestion)
  //   return (
  //     <div className="fixed inset-0 z-50 bg-white/60 backdrop-blur-sm flex items-center justify-center pointer-events-auto">
  //       <div className="flex flex-col items-center justify-center space-y-4">
  //         <div className="w-16 h-16 border-4 border-gray-300 border-t-[#54B0AF] rounded-full animate-spin"></div>
  //       </div>
  //     </div>
  //   );

  return (
    <div className="w-full p-6 font-sans text-gray-800 bg-[#F2F2F2] min-h-screen relative">
      <div className="container mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8 mt-4">
          <button
            // onClick={() => navigate("/workspace")}
            onClick={() => {
              navigate("/workspace", { state: { storyId } });
              console.log("Back button is clicked");
            }}
            className="flex items-center text-xl lg:text-2xl text-[#323232] font-gotham font-medium hover:text-gray-800"
          >
            <ChevronLeft className="w-4 h-4 mr-1 text-xl lg:text-2xl" />
            Back
          </button>
          <div className="hidden md:flex items-center group relative">
            {isEditing ? (
              <input
                type="text"
                autoFocus
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                onBlur={() => setIsEditing(false)}
                onKeyDown={(e) => e.key === "Enter" && handleSave()}
                className="text-xl md:text-3xl lg:text-4xl font-bold font-gotham text-[#323232] border-b border-gray-400 outline-none bg-transparent px-1 w-full min-w-[36rem] overflow-hidden"
                style={{ height: "auto" }}
              />
            ) : (
              <h1
                onClick={() => setIsEditing(true)}
                className="text-xl md:text-3xl lg:text-[32px] font-bold font-gotham text-[#323232] px-3 md:px-0 cursor-pointer group-hover:underline transition duration-200 ease-in-out"
              >
                {title}
              </h1>
            )}

            {!isEditing && (
              <button
                onClick={() => setIsEditing(true)}
                className="absolute -right-16 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out w-20 h-20 flex items-center justify-center"
              >
                <PencilLine className="w-10 h-10 text-gray-500 hover:text-gray-700" />
              </button>
            )}
          </div>

          <div className="flex items-center bg-white  rounded-full shadow-sm">
            {/* <div className="flex items-center bg-white px-3 py-2 rounded-full shadow-sm"> */}
            {/* <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
            <span className="text-sm font-medium text-[#323232]">
              {data?.mood}
            </span> */}
          </div>
        </div>

        <div className="relative w-full px-3 md:px-0 mb-3 flex justify-center items-center md:hidden">
          {isEditing ? (
            <input
              type="text"
              autoFocus
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onBlur={() => setIsEditing(false)}
              onKeyDown={(e) => e.key === "Enter" && handleSave()}
              className="text-xl md:text-3xl lg:text-[32px] font-bold font-gotham text-[#323232] border-b border-gray-400 outline-none bg-transparent w-full max-w-full"
            />
          ) : (
            <h1
              onClick={() => setIsEditing(true)}
              className="text-xl md:text-3xl lg:text-4xl font-bold font-gotham text-[#323232] w-full cursor-pointer group-hover:underline transition duration-200 ease-in-out"
            >
              {title}
            </h1>
          )}

          {!isEditing && (
            <button
              onClick={() => {
                setIsEditing(true);
              }}
              className="absolute right-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out"
            >
              <Pencil className="w-4 h-4 text-[#323232] hover:text-gray-800" />
            </button>
          )}
        </div>

        {/* Intro Section with Panda */}
        <div className="flex flex-col lg:flex-row items-start gap-6 mb-8 mt-3 md:mt-0">
          {/* Text Container */}
          <div className="flex-1 rounded-2xl bg-white p-6 sm:p-8 min-h-[160px] flex items-center justify-center">
            <p className="text-[#666666] text-sm sm:text-base lg:text-xl font-gotham font-medium leading-relaxed text-center lg:text-left">
              {titleAndIdData.conversation_history ?? "We are working on it..."}
            </p>
          </div>

          {/* Image Container */}
          <div className="w-full sm:w-1/2 lg:w-[20%] min-h-[160px] h-36 bg-[#54B0AF] rounded-2xl flex items-center justify-center">
            <img
              src={pandaImg}
              alt="Panda"
              className="h-full max-h-80 object-containx"
            />
          </div>
        </div>

        {/* Future ID and Tabs Section */}
        <div className="flex flex-col md:flex-row items-stretch gap-4 md:gap-6 mb-8">
          <div className="bg-white p-6 rounded-2xl shadow-sm w-full md:max-w-xs group relative">
            {/* Notch with edit button */}
            <div className="flex justify-center mb-3 relative">
              <div className="w-12 h-3 bg-gray-300 rounded-full"></div>

              {!isEditingFutureId && (
                <button
                  onClick={() => setIsEditingFutureId(true)}
                  className="absolute right-0 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out w-8 h-8 flex items-center justify-center"
                >
                  <PencilLine className="w-5 h-5 text-[#323232] hover:text-gray-800" />
                </button>
              )}
            </div>

            {isEditingFutureId ? (
              <>
                <textarea
                  autoFocus
                  value={futureIdData.title}
                  onChange={(e) =>
                    setFutureIdData({ ...futureIdData, title: e.target.value })
                  }
                  className="text-2xl font-bold mb-4 text-center font-gotham w-full border-b border-gray-400"
                />
                <div className="flex justify-center mb-4">
                  <div className="w-40 h-40 bg-gray-100 rounded-full flex items-center justify-center">
                    <img src={futImg} alt="" />
                  </div>
                </div>
                <textarea
                  value={futureIdData.description}
                  onChange={(e) =>
                    setFutureIdData({
                      ...futureIdData,
                      description: e.target.value,
                    })
                  }
                  className="text-base md:text-lg font-gotham font-medium text-[#1D1D1D] border-b border-gray-400 outline-none bg-transparent px-1 w-full overflow-hidden resize-none"
                  rows={4}
                />
                <button
                  className="mt-4 px-4 py-2 bg-[#54B0AF] text-white rounded-xl"
                  onClick={handleFutureIdSave}
                >
                  Save
                </button>
              </>
            ) : (
              <>
                <h3 className="text-xl md:text-2xl font-bold mb-4 text-center font-gotham cursor-pointer">
                  {futureIdData.title || "Future ID"}
                </h3>
                <div className="flex justify-center mb-4">
                  <div className="w-40 h-40 bg-gray-100 rounded-full flex items-center justify-center">
                    <img src={futImg} alt="" />
                  </div>
                </div>
                <div className="text-base font-gotham font-medium text-[#666666] cursor-pointer transition duration-200 ease-in-out px-1">
                  {futureIdData.description ?? "We are working on it..."}
                </div>
              </>
            )}
          </div>

          {/* Tabs Section */}
          <div className="flex-1 bg-white rounded-2xl shadow-sm">
            {/* Tab Navigation */}
            <div className="flex border-b-[20px] gap-2 md:gap-4 bg-[#F2F2F2]  border-gray-100">
              {["Unresolved", "Unspoken", "Incomplete"].map((t) => (
                <button
                  key={t}
                  onClick={() => {
                    console.log(t);
                    setTab(t);
                    getThreadsBasedOnTab(t);
                  }}
                  className={`flex-1 px-4 py-3 text-xs font-bold font-gotham md:text-lg lg:text-2xl rounded-xl ${
                    tab === t
                      ? "bg-[#54B0AF] text-white"
                      : "text-[#1D1D1D] hover:text-gray-800 bg-white"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
            {/* Tab Content */}
            <div className="p-3 sm:p-6 items-stretch bg-white rounded-2xl">
              <div className="mb-4">
                <h4 className="text-lg md:text-2xl text-[#323232] font-bold font-gotham mb-2">
                  {tab}
                </h4>
                <p className="text-sm md:text-[16px] text-[#666666] font-gotham font-medium">
                  Hints were there, but the real topic never surfaced. These are
                  the threads waiting to be named.
                </p>
              </div>

              <div className="space-y-3 overflow-hidden h-auto">
                {threads.map((item, idx) => {
                  const isSelected = selectedForStartReflection === item;

                  return (
                    <div
                      key={idx}
                      className={`flex items-center justify-between text-justify p-1 sm:p-4 border-b-2 border-[#F5F5F5] cursor-pointer group rounded-md transition-all duration-200 ease-in-out`}
                    >
                      {/* Left side - Item text */}
                      <span
                        className={`text-sm md:text-lg font-normal w-full font-gotham text-[#323232] transform transition-all duration-300 ease-in-out
                  ${
                    isSelected
                      ? "-translate-x-20"
                      : "group-hover:-translate-x-20"
                  }`}
                      >
                        {/* {item} */}
                        <p>
                          {item.observation ?? "We are working on it..."}{" "}
                          {item.contradiction}{" "}
                          <span className="text-[#54A0A9]">
                            {item.punchline}
                          </span>
                        </p>
                      </span>

                      {/* Right side - icon or text + icon on hover */}
                      <div className="flex items-center space-x-1 sm:space-x-2">
                        {/* Default ChevronRight when not hovered or selected */}
                        <ChevronRight
                          className={`w-6 h-6 transition-opacity duration-150 ml-1 ease-in-out text-gray-400
                            ${isSelected ? "hidden" : "group-hover:hidden"}`}
                        />

                        {/* Show on hover or when selected */}
                        <div
                          className={`flex flex-col sm:flex-row items-center gap-1 text-[10px] sm:text-sm text-[#323232] font-medium opacity-0 group-hover:opacity-100 ${
                            isSelected ? "opacity-100" : ""
                          } transition-opacity duration-200`}
                          onClick={() => {
                            setSelectedForStartReflection(item.punchline);
                          }}
                        >
                          <span className="text-[#54B0AF]  underline">
                            Continue Untangling
                          </span>
                          <div className="w-6 h-6 flex items-center justify-center bg-gray-200 rounded-full">
                            <NotebookPen className="w-3.5 h-3.5 text-[#323232]" />
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Trigger point for floating button - This is where the button should start appearing */}
        <div ref={triggerRef} className="flex items-center justify-start p-6">
          <div className="text-start max-w-full w-full">
            <h1 className="text-2xl md:text-[48px] font-bold text-[#E3E3E3] mb-3 leading-7 md:leading-[3rem] font-gotham">
              {assurenceAndDeepQuestion.assurance ?? "We are working on it..."}
            </h1>
            <div className="flex items-center justify-between mt-5">
              <p className="text-sm md:text-xl text-[#666666] font-medium leading-relaxed">
                {assurenceAndDeepQuestion.question ?? "We are working on it..."}
              </p>

              <button
                title="Let's Reflect"
                onClick={() => {
                  setSelectedForStartReflection(
                    assurenceAndDeepQuestion.question
                  );
                }}
                className="ml-4 flex items-center gap-2 font-medium text-sm md:text-base text-[#54B0AF] underline"
              >
                <div className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full">
                  <NotebookPen className="w-5 h-5" />
                </div>
              </button>
            </div>
          </div>
        </div>

        {/* Stake and Barriers Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 font-gotham py-6">
          {/* My Barriers */}
          <div className="bg-white p-6 rounded-2xl shadow-sm flex flex-col min-h-[300px] relative">
            <div>
              <h3 className="text-lg md:text-2xl text-[#1D1D1D] font-gotham font-bold mb-4">
                My Barriers
              </h3>

              <p className="text-sm md:text-xl font-medium font-gotham text-[#888888] mb-4 mt-4">
                Forces causing friction or holding you back.
              </p>

              <div className="flex gap-4 mb-4 bg-[#54B0AF] rounded-2xl p-1 mt-5">
                <button
                  onClick={() => setBarrierTab("Internal")}
                  className={`px-4 py-2 w-full rounded-[20px] text-sm md:text-xl font-medium font-gotham transition-all duration-150 ${
                    barrierTab === "Internal"
                      ? "bg-white text-[#323232]"
                      : "text-[#FFFFFF]"
                  }`}
                >
                  Internal barrier
                </button>
                <button
                  onClick={() => setBarrierTab("External")}
                  className={`px-4 py-2 w-full rounded-[14px] text-sm md:text-lg font-medium font-gotham transition-all duration-150 ${
                    barrierTab === "External"
                      ? "bg-white text-[#323232]"
                      : "text-[#FFFFFF]"
                  }`}
                >
                  External barrier
                </button>
              </div>
            </div>

            <div className="flex-grow">
              <div className="flex-grow overflow-hidden relative">
                <div className="max-h-[250px] overflow-y-auto pr-1 custom-scrollbar"></div>
                <ul className="space-y-2 mb-4">
                  {data?.barriers.options[barrierTab]?.length === 0 ? (
                    <p className="text-[#888888] text-sm md:text-xl font-gotham font-medium">
                      {barrierTab === "Internal"
                        ? "No internal barriers found."
                        : "No external barriers found."}
                    </p>
                  ) : (
                    data?.barriers.options[barrierTab]
                      ?.slice()
                      .reverse()
                      .map((point, idx) => {
                        const isExpanded = activeBarrierIdx === idx;
                        const barrierData = [
                          ...allBarriers.internal,
                          ...allBarriers.external,
                        ].find((b) => b.label === point);

                        return (
                          <li
                            key={idx}
                            onMouseEnter={() => {
                              if (!isNoExternalBarrier) {
                                setActiveBarrierIdx(idx);
                              }
                            }}
                            onMouseLeave={() => {
                              if (!isNoExternalBarrier) {
                                setActiveBarrierIdx(null);
                              }
                            }}
                            className={`flex flex-col text-sm md:text-[16px] font-gotham font-medium rounded-xl p-2 transition-all ${
                              !isNoExternalBarrier ? "cursor-pointer group" : ""
                            }`}
                          >
                            <div className="flex items-center justify-between">
                              <span className="text-sm md:text-xl font-medium text-[#484848] truncate">
                                {point ?? "We are working on it..."}
                              </span>

                              {!isNoExternalBarrier && (
                                <div
                                  className={`flex items-center gap-1 text-sm text-[#323232] font-medium transition-opacity duration-300 ${
                                    selectedForStartReflection === point
                                      ? "opacity-100"
                                      : "opacity-0 group-hover:opacity-100"
                                  }`}
                                  onClick={() => {
                                    // console.log(
                                    //   "Clicked label:",
                                    //   barrierData.label
                                    // );
                                    // console.log(
                                    //   "Explanation:",
                                    //   barrierData.explanation
                                    // );
                                    setSelectedForStartReflection(
                                      barrierData.label
                                    );
                                  }}
                                >
                                  <span className="text-[#54B0AF] underline whitespace-nowrap">
                                    Let's Address
                                  </span>
                                  <div className="w-6 h-6 flex items-center justify-center bg-gray-200 rounded-full">
                                    <NotebookPen className="w-3.5 h-3.5 text-[#323232]" />
                                  </div>
                                </div>
                              )}
                              {!isNoExternalBarrier && (
                                <ChevronRight
                                  className={`w-4 h-4 transition-opacity duration-150 ease-in-out text-gray-400
                            ${
                              selectedForStartReflection === point
                                ? "hidden"
                                : "group-hover:hidden"
                            }`}
                                />
                              )}
                            </div>

                            <AnimatePresence initial={false}>
                              {isExpanded && barrierData?.explanation && (
                                <motion.div
                                  key="explanation"
                                  initial={{ opacity: 0, height: 0 }}
                                  animate={{ opacity: 1, height: "auto" }}
                                  exit={{ opacity: 0, height: 0 }}
                                  transition={{ duration: 0.3 }}
                                  className="overflow-hidden"
                                >
                                  <p className="text-[#666] text-base font-medium p-2">
                                    {barrierData.explanation}
                                  </p>
                                </motion.div>
                              )}
                            </AnimatePresence>
                          </li>
                        );
                      })
                  )}
                </ul>
              </div>
            </div>

            <button
              className="flex items-center text-sm md:text-[18px] text-[#1D1D1D] font-medium hover:text-gray-800 mt-10"
              onClick={() =>
                handleOpenModal(
                  "All Barriers",
                  [...allBarriers.internal, ...allBarriers.external],
                  "barriers"
                )
              }
            >
              <span className="font-medium underline">View all</span>
              <FiArrowRight className="w-4 h-4" />
            </button>

            <img
              src={emoji1}
              alt=""
              className="w-10 h-10 absolute bottom-5 right-5"
            />
          </div>

          {/* My Stake */}

          <div className="bg-white p-6 rounded-2xl shadow-sm flex flex-col min-h-[300px] relative">
            <div>
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg md:text-2xl text-[#1D1D1D] font-bold font-gotham">
                  My Stake
                </h3>
                <div className="w-8 h-8 bg-[#FFE5E5] rounded-full flex justify-center items-center">
                  <div className="w-2.5 h-2.5 bg-[#FF0000B2] rounded-full"></div>
                </div>
              </div>

              <p className="text-sm md:text-xl text-[#888888] font-medium font-gotham mb-4">
                Possible outcomes if you don't act in time.
              </p>

              <div className="flex gap-4 mb-4 bg-[#54B0AF] rounded-[20px] mt-5 p-1">
                {["Recoverable", "Critical"].map((key) => (
                  <button
                    key={key}
                    onClick={() => setStakeTab(key)}
                    className={`px-4 py-2 w-full rounded-[14px] text-sm md:text-xl font-medium font-gotham transition-all duration-150 ${
                      stakeTab === key
                        ? "bg-white text-[#323232]"
                        : "text-[#FFFFFF]"
                    }`}
                  >
                    {key}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex-grow">
              <ul className="space-y-2 mb-4">
                {stakeData[stakeTab]?.length > 0 ? (
                  stakeData[stakeTab]?.map((point, idx) => {
                    const [stakeName, implication] = point.split(": ");
                    const isExpanded = activeStakeIdx === idx;

                    return (
                      <li
                        key={idx}
                        onMouseEnter={() => setActiveStakeIdx(idx)}
                        onMouseLeave={() => setActiveStakeIdx(null)}
                        className="flex flex-col text-sm md:text-[16px] font-gotham font-medium rounded-xl p-2 transition-all cursor-pointer group"
                      >
                        <div className="flex items-center justify-between">
                          <span className="text-sm md:text-xl font-medium text-[#484848] truncate">
                            {stakeName ?? "We are working on it..."}
                          </span>

                          <div
                            className={`flex items-center gap-1 text-sm text-[#323232] font-medium transition-opacity duration-300 ${
                              selectedForStartReflection === stakeName
                                ? "opacity-100"
                                : "opacity-0 group-hover:opacity-100"
                            }`}
                          >
                            <button
                              onClick={() => {
                                setSelectedForStartReflection(implication);
                                // call your reflection handler here
                              }}
                              className="text-[#54B0AF] underline whitespace-nowrap"
                            >
                              Let's Address
                            </button>
                            <div className="w-6 h-6 flex items-center justify-center bg-gray-200 rounded-full">
                              <NotebookPen className="w-3.5 h-3.5 text-[#323232]" />
                            </div>
                          </div>

                          <ChevronRight
                            className={`w-4 h-4 transition-opacity duration-150 ease-in-out text-gray-400
                            ${
                              selectedForStartReflection === point
                                ? "hidden"
                                : "group-hover:hidden"
                            }`}
                          />
                        </div>

                        <AnimatePresence initial={false}>
                          {isExpanded && implication && (
                            <motion.div
                              key="implication"
                              initial={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                              exit={{ opacity: 0, height: 0 }}
                              transition={{ duration: 0.3 }}
                              className="overflow-hidden"
                            >
                              <p className="text-[#666] font-medium p-2">
                                {implication}
                              </p>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </li>
                    );
                  })
                ) : (
                  <p className="text-[#888888] text-sm md:text-xl font-gotham font-medium">
                    No {stakeTab.toLowerCase()} stakes found.
                  </p>
                )}
              </ul>
            </div>

            <button
              className="flex items-center text-sm md:text-xl text-[#1D1D1D] font-gotham font-medium hover:text-gray-800 mt-10"
              onClick={() => {
                // const transformedStakeData = Object.entries(stakeData).flatMap(
                //   ([riskType, stakesArray]) =>
                //     stakesArray.map((stakeItem) => {
                //       const [stakeName, implication] = stakeItem.split(": ");
                //       return { riskType, stakeName, implication };
                //     })
                // );

                handleOpenModal(
                  "All Stakes",
                  [
                    ...stakeData.Recoverable.map((item) => ({
                      stakeName: item.split(":")[0],
                      implication: item.split(":")[1],
                      riskType: "Recoverable",
                    })),
                    ...stakeData.Critical.map((item) => ({
                      stakeName: item.split(":")[0],
                      implication: item.split(":")[1],
                      riskType: "Critical",
                    })),
                  ],
                  "stakes"
                );
              }}
            >
              <span className="font-medium underline">View all</span>
              <FiArrowRight className="w-4 h-4" />
            </button>

            <img
              src={emoji2}
              alt=""
              className="w-10 h-10 absolute bottom-5 right-5"
            />
          </div>
        </div>

        {/* Blind Spots Section */}
        <div className="py-6">
          <div className="flex flex-col items-center justify-center">
            <h3 className="text-lg md:text-xl lg:text-2xl text-[#1D1D1D] font-bold font-gotham mb-2">
              My Blind Spots
            </h3>
            <p className="text-sm md:text-xl text-[#888888] font-gotham font-medium mb-2 sm:mb-6 w-[60%] mt-4 text-center md:leading-7 leading-6">
              Blind spots are habits or patterns you don't notice, but they
              quietly shape your decisions. Not seen, but strongly felt.
            </p>
          </div>

          <div className="flex justify-between items-center mt-2 sm:mt-4">
            <div className="w-full max-w-full mx-auto p-1">
              <div className="relative flex items-center justify-center py-4">
                {/* Left Arrow */}
                <button
                  onClick={goToPrevious}
                  className="absolute left-0 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow duration-200"
                >
                  <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>

                <div className="flex justify-center items-start w-full max-w-full overflow-hidden py-3">
                  <div
                    className="flex gap-4"
                    style={{
                      transform: `translateX(${animationOffset}px)`,
                      transition: isAnimating
                        ? "transform 0.4s ease-in-out"
                        : "none",
                    }}
                  >
                    {getVisibleCards().map((card, idx) => {
                      const { position } = card;
                      const isCenter = position === 0;
                      const isSide = Math.abs(position) === 1;
                      const isEdge = Math.abs(position) === 2;

                      let scale = 1;
                      let opacity = 1;
                      let translateX = 0;

                      if (isSide) {
                        scale = 0.95;
                        opacity = 0.5;
                      } else if (isEdge) {
                        scale = 0.9;
                        opacity = 0.25;
                        translateX = position === -2 ? 5 : -5;
                      }

                      const labelSize = isCenter
                        ? "text-lg md:text-xl"
                        : isSide
                        ? "text-base"
                        : "text-base";
                      const explanationSize = isCenter
                        ? "text-sm md:text-lg"
                        : isSide
                        ? "text-sm"
                        : "text-sm";

                      return (
                        <div
                          key={`${card.index}-${idx}`}
                          className="bg-white rounded-[20px] shadow-md p-6 relative"
                          style={{
                            width: isCenter ? "300px" : "270px",
                            minWidth: isCenter ? "320px" : "280px",
                            height: isCenter
                              ? "360px"
                              : isEdge
                              ? "300px"
                              : "330px",
                            flexShrink: 0,
                            transform: `scale(${scale}) translateX(${translateX}px)`,
                            opacity,
                            transition: "all 0.5s ease-in-out",
                          }}
                        >
                          <div className="h-full flex flex-col justify-between overflow-hidden">
                            {/* Title */}
                            <div
                              className={`font-bold mb-2 text-[#1D1D1D] font-gotham break-words whitespace-normal leading-tight ${labelSize}`}
                            >
                              {card.label}
                            </div>

                            {/* Fixed Button */}
                            {isCenter && (
                              <button
                                title="Let's Reflect"
                                onClick={() => {
                                  setSelectedForStartReflection(card.label);
                                }}
                                className={`absolute top-2 right-2 flex items-center gap-2 font-medium ${
                                  isCenter ? "text-sm md:text-base" : "text-xs"
                                } text-[#54B0AF] underline`}
                              >
                                <div className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full">
                                  <NotebookPen className="w-5 h-5" />
                                </div>
                              </button>
                            )}

                            {/* Explanation */}
                            <div
                              className={`font-gotham font-medium text-[#323232] break-words leading-relaxed overflow-hidden ${explanationSize}`}
                              style={{
                                flexGrow: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: isCenter ? 5 : isSide ? 4 : 3,
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {card.explanation}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Mobile View: Show only center card */}
                <div className="md:hidden w-full flex justify-center px-4">
                  <div className="bg-white rounded-[20px] shadow-md p-6 w-80 h-64">
                    <div className="h-full flex flex-col justify-start">
                      <div className="font-bold mb-4 text-[#1D1D1D] text-lg">
                        {extendedBlindSpots[currentIndex]?.label}
                      </div>
                      <div className="text-sm text-[#323232]">
                        {extendedBlindSpots[currentIndex]?.explanation}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Arrow */}
                <button
                  onClick={goToNext}
                  className="absolute right-0 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow duration-200"
                >
                  <ChevronRight className="w-6 h-6 text-gray-600" />
                </button>
              </div>

              {/* View All Link Button */}
              <div className="flex justify-center mt-4">
                <button
                  className="flex items-center text-sm md:text-xl text-[#1D1D1D] font-gotham font-medium hover:text-gray-900 transition-colors duration-200"
                  onClick={() =>
                    handleOpenModal(
                      "All Blind Spots",
                      blindSpots,
                      "blind_spots"
                    )
                  }
                >
                  <span className="font-medium underline">View all</span>
                  <FiArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="py-5">
          <div
            className={`max-w-full w-full mx-auto flex flex-col ${
              hasActions ? "md:flex-row" : "items-center"
            } gap-5`}
          >
            {/* Left Card */}
            <div
              className={`w-full ${
                hasActions ? "md:w-[50%]" : "md:w-[60%]"
              } bg-gradient-to-b from-[#FFFFFF] to-[#D7EDED] rounded-xl p-6 shadow-sm border border-gray-200 flex flex-col justify-between min-h-[300px]`}
            >
              {/* Header with sparkle icons */}
              <div className="flex items-center justify-center gap-3 mb-4">
                <img src={stars} alt="" className="rotate-180" />
                <h2 className="text-base md:text-2xl font-bold font-gotham text-[#1D1D1D] ">
                  Where This Could Go
                </h2>
                <img src={stars} alt="" />
              </div>

              {/* Main content */}
              <p className="leading-relaxed mb-6 text-[#222222] px-4 md:px-12 text-sm md:text-lg lg:text-xl font-gotham font-medium">
                {isExpanded
                  ? heroStory ?? "We are working on it..."
                  : getPreview(heroStory) ?? "We are working on it..."}
              </p>

              {/* Read more button */}
              <div className="text-center">
                {heroStory && (
                  <div className="text-center">
                    <button
                      onClick={() =>
                        handleOpenModal(
                          "Where This Could Go",
                          [heroStory],
                          "hero"
                        )
                      }
                      className="text-[#1D1D1D] font-gotham text-sm md:text-xl font-medium underline hover:text-gray-900 transition-colors"
                    >
                      Read more
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Right Card */}
            {hasActions && (
              <div className="w-full md:w-[50%] bg-white rounded-xl p-6 shadow-sm border border-gray-200 flex flex-col justify-between min-h-[300px]">
                <div>
                  <h3 className="text-base md:text-2xl font-bold font-gotham text-[#1D1D1D] mb-4 mt-2">
                    My Actions
                  </h3>

                  {/* Tabs */}
                  <div className="flex gap-4 mb-4 bg-[#54B0AF] rounded-[20px] mt-5 p-1 w-full">
                    {actionsTabs.map((tab) => (
                      <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        className={`px-4 py-2 w-1/3 rounded-[14px] text-sm md:text-xl font-medium font-gotham transition-all duration-150 ${
                          activeTab === tab
                            ? "bg-white text-[#323232]"
                            : "text-[#FFFFFF]"
                        }`}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>

                  {/* Action List */}
                  <ul className="space-y-2 mt-2">
                    {actionsByFreq[activeTab]?.length > 0 ? (
                      actionsByFreq[activeTab].map((action, idx) => (
                        <li
                          key={idx}
                          className="flex items-center justify-between text-sm md:text-[16px] font-gotham font-medium cursor-pointer rounded-md py-1 px-2 transition-all group hover:bg-gray-100"
                        >
                          <div className="flex items-start gap-3">
                            <span className="w-2 h-2 bg-[#484848] rounded-full mt-1 flex-shrink-0"></span>
                            <span className="text-[#484848] font-medium font-gotham text-base">
                              {action.action}
                            </span>
                          </div>

                          <div className="flex items-center gap-2 text-sm text-[#323232] font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <button
                              // onClick={() => handleMarkDone(action)}
                              className="text-[#54B0AF] underline"
                            >
                              Mark It As Done
                            </button>
                            <div
                              className="w-6 h-6 flex items-center justify-center bg-gray-200 rounded-full"
                              // onClick={() => handleDelete(action)}
                            >
                              <Trash className="w-3.5 h-3.5 text-[#323232]" />
                            </div>
                          </div>
                        </li>
                      ))
                    ) : (
                      <p className="text-sm text-gray-500 font-gotham font-medium px-2">
                        No actions found for {activeTab}.
                      </p>
                    )}
                  </ul>
                </div>

                <div className="flex justify-center mt-4">
                  <button
                    className="flex items-center text-sm md:text-xl text-[#1D1D1D] font-gotham font-medium hover:text-gray-900 transition-colors duration-200"
                    onClick={() => {
                      console.log(actionsByFreq);
                      handleOpenModal("All Action", actionsByFreq, "action");
                    }}
                  >
                    <span className="font-medium underline">View all</span>
                    <FiArrowRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Static button in footer */}
          <div
            ref={footerRef}
            className={`mt-4 flex justify-end items-center transition-opacity duration-300 ${
              showFloatingButton ? "opacity-50" : "opacity-100"
            }`}
          >
            <button
              className="w-full max-w-52 bg-[#54B0AF] hover:bg-teal-600 text-[#FFFFFF] rounded-[20px] px-4 py-4 text-sm font-medium md:text-[16px] font-gotham flex items-center justify-center gap-2 transition-colors"
              onClick={() => {
                setNewChapter(true);
                // handleNewChapter();
              }}
            >
              <FiEdit className="w-4 h-4 text-[#FFFFFF] text-base font-gotham font-medium" />
              Start Reflection
            </button>
          </div>
        </div>

        {/* Floating Start Reflection Button */}
        {showFloatingButton && (
          <div className="fixed bottom-8 right-8 z-50 animate-fade-in">
            <button
              className="bg-[#54B0AF] hover:bg-teal-600 text-[#FFFFFF] rounded-2xl px-6 py-4 text-sm font-medium md:text-[16px] font-gotham flex items-center justify-center gap-2 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
              onClick={() => {
                setNewChapter(true);
                // handleNewChapter();
              }}
            >
              <FiEdit className="w-4 h-4 text-[#FFFFFF] font-gotham font-medium" />
              Start Reflection
            </button>
          </div>
        )}

        <PopupModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          title={modalTitle}
          items={modalData}
          type={modalType}
        />

        {/* Add custom CSS for fade-in animation */}
        <style jsx>{`
          @keyframes fade-in {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .animate-fade-in {
            animation: fade-in 0.3s ease-out;
          }
        `}</style>
        {isLoading && (
          <div className="fixed inset-0 z-50 bg-white/60 backdrop-blur-sm flex items-center justify-center pointer-events-auto">
            <div className="flex flex-col items-center justify-center space-y-4">
              <div className="w-16 h-16 border-4 border-gray-300 border-t-[#54B0AF] rounded-full animate-spin"></div>
              <span className="text-gray-400 italic text-sm">
                {isLoadingData}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StoryDetails;

// import React, { useEffect, useState, useRef, useContext } from "react";
// import {
//   ChevronRight,
//   ChevronLeft,
//   Pencil,
//   NotebookPen,
//   Trash,
//   PencilLine,
// } from "lucide-react";
// import futImg from "../../../assets/DashIllustration.png";
// import pandaImg from "../../../assets/StoryPanda.png";
// import stars from "../../../assets/stars.png";
// import emoji1 from "../../../assets/Emoji1.png";
// import emoji2 from "../../../assets/Emoji2.png";
// import { FiEdit } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import { UserContext } from "../../../UserContext";
// import PopupModal from "./PopupModal";
// import { useParams } from "react-router-dom";
// import { FiArrowRight } from "react-icons/fi";
// import { motion, AnimatePresence } from "framer-motion";

// const fetchData = async () => {
//   const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;

//   return {
//     mood: "Optimistic",
//     futureId: {
//       title: "Future Id",
//       description:
//         "Product design specialist turning bold ideas into scalable digital experiences.\n\nKnown for clarity, strategy, and sharp execution.",
//       image: "https://i.imgur.com/1Q9Z1Zm.png",
//     },
//     incomplete: [],
//     stake: {
//       active: "Recoverable",
//       options: {
//         Recoverable: [],
//         Critical: [],
//       },
//     },
//     barriers: {
//       active: "Internal",
//       options: {
//         External: [],
//         Internal: [],
//       },
//     },
//     blindSpots: [],
//   };
// };

// const actionsTabs = ["Daily", "Weekly", "Monthly"];

// const StoryDetails = () => {
//   const { storyId } = useParams();
//   const [data, setData] = useState(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [title, setTitle] = useState("");
//   const [isEditingFutureId, setIsEditingFutureId] = useState(false);

//   const [futureIdData, setFutureIdData] = useState({
//     title: "future ID",
//     description: "future Discription",
//   });

//   const [tab, setTab] = useState("Unresolved");
//   const [stakeData, setStakeData] = useState({
//     Recoverable: [],
//     Critical: [],
//   });

//   const [stakeTab, setStakeTab] = useState("Recoverable");

//   const [barrierTab, setBarrierTab] = useState("Internal");
//   const [activeTab, setActiveTab] = useState("Monthly");

//   const [titleAndIdData, setTitleAndIdData] = useState("");
//   const [showFloatingButton, setShowFloatingButton] = useState(false);
//   const [threads, setThreads] = useState([]);
//   const [incompleteThreads, setIncompleteThreads] = useState([]);
//   const [unresolvedThreads, setUnresolvedThreads] = useState([]);
//   const [unSpokenThreads, setUnSpokenThreads] = useState([]);
//   const [assurenceAndDeepQuestion, setAssurenceAndDeepQuestion] = useState("");
//   const [allBarriers, setAllBarriers] = useState({
//     internal: [],
//     external: [],
//   });

//   const [recentBarriers, setRecentBarriers] = useState({
//     internal: [],
//     external: [],
//   });
//   const [heroStory, setHeroStory] = useState("");
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [blindSpots, setBlindSpots] = useState([]);

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalData, setModalData] = useState([]);
//   const [modalTitle, setModalTitle] = useState("");
//   const [modalType, setModalType] = useState("");

//   const [selectedForStartReflection, setSelectedForStartReflection] =
//     useState(null);
//   const [newChapter, setNewChapter] = useState(false);

//   const [isLoading, setIsLoading] = useState(false);
//   const [isLoadingData, setIsLoadingData] = useState("");

//   const [activeBarrierIdx, setActiveBarrierIdx] = useState(null);
//   const [activeStakeIdx, setActiveStakeIdx] = useState(null);

//   const [actionsByFreq, setActionsByFreq] = useState({
//     Daily: [],
//     Weekly: [],
//     Monthly: [],
//   });
//   const [activeActionTab, setActiveActionTab] = useState("Daily");
//   const [hasActions, setHasActions] = useState(false);

//   // const cardWidth = 350; // consistent card width
//   // const scrollOffset = cardWidth; // scroll one card at a time
//   const scrollContainerRef = useRef(null);
//   const cardRef = useRef(null); // to measure real card width
//   const [visibleCardCount, setVisibleCardCount] = useState(3); // responsive card count
//   const [currentCenterIndex, setCurrentCenterIndex] = useState(1); // Start with middle card highlighted
//   const totalOriginal = blindSpots.length;
//   // const [cardWidth, setCardWidth] = useState(
//   //   window.innerWidth < 768 ? 230 : 350
//   // );
//   const cardGap = 30;
//   const [isScrolling, setIsScrolling] = useState(false);
//   const navigate = useNavigate();
//   const { user } = useContext(UserContext);
//   const triggerRef = useRef(null);
//   const footerRef = useRef(null);

//   const [currentIndex, setCurrentIndex] = useState(2);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [animationOffset, setAnimationOffset] = useState(0);
//   const [cardWidth, setCardWidth] = useState(
//     window.innerWidth < 768 ? 260 : 360
//   );
//   const isMobile = window.innerWidth < 768;

//   const extendedBlindSpots = [
//     ...blindSpots.slice(-2),
//     ...blindSpots,
//     ...blindSpots.slice(0, 2),
//   ];

//   useEffect(() => {
//     const handleResize = () => {
//       setCardWidth(window.innerWidth < 768 ? 260 : 360);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const getVisibleCards = () => {
//     const cards = [];
//     for (let i = -2; i <= 2; i++) {
//       const index =
//         (currentIndex + i + extendedBlindSpots.length) %
//         extendedBlindSpots.length;
//       cards.push({ ...extendedBlindSpots[index], position: i, index });
//     }
//     return cards;
//   };

//   const goToPrevious = () => {
//     if (isAnimating) return;
//     setAnimationOffset(cardWidth);
//     setIsAnimating(true);
//     setTimeout(() => {
//       setCurrentIndex(
//         (prev) =>
//           (prev - 1 + extendedBlindSpots.length) % extendedBlindSpots.length
//       );
//       setAnimationOffset(0);
//       setIsAnimating(false);
//     }, 400);
//   };

//   const goToNext = () => {
//     if (isAnimating) return;
//     setAnimationOffset(-cardWidth);
//     setIsAnimating(true);
//     setTimeout(() => {
//       setCurrentIndex((prev) => (prev + 1) % extendedBlindSpots.length);
//       setAnimationOffset(0);
//       setIsAnimating(false);
//     }, 400);
//   };

//   const scrollToIndex = (index, smooth = true) => {
//     if (!scrollContainerRef.current) return;
//     const containerWidth = scrollContainerRef.current.offsetWidth;
//     const scrollTo =
//       index * (cardWidth + cardGap) - containerWidth / 2 + cardWidth / 2;

//     scrollContainerRef.current.scrollTo({
//       left: scrollTo,
//       behavior: smooth ? "smooth" : "auto",
//     });
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const isMobile = window.innerWidth < 768;
//       setVisibleCardCount(isMobile ? 1 : 3);
//       setCardWidth(isMobile ? 230 : 360);
//       setCurrentCenterIndex(isMobile ? 1 : 2);
//     };
//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     const startIndex = visibleCardCount === 1 ? 1 : 2;
//     scrollToIndex(startIndex, false);
//     setCurrentCenterIndex(startIndex);
//   }, [visibleCardCount, cardWidth]);

//   const handleScroll = () => {
//     if (!scrollContainerRef.current || isScrolling) return;
//     const scrollLeftPos = scrollContainerRef.current.scrollLeft;
//     const containerWidth = scrollContainerRef.current.clientWidth;
//     const center = scrollLeftPos + containerWidth / 2;
//     const totalCardSize = cardWidth + cardGap;
//     const newIndex = Math.round(center / totalCardSize);
//     const buffer = visibleCardCount === 1 ? 1 : 2;
//     const maxIndex = totalOriginal + buffer;

//     if (newIndex <= buffer - 1) {
//       const jumpToIndex = totalOriginal + (newIndex - buffer + 1);
//       setTimeout(() => {
//         scrollToIndex(jumpToIndex, false);
//         setCurrentCenterIndex(jumpToIndex);
//       }, 100);
//     } else if (newIndex >= maxIndex + 1) {
//       const jumpToIndex = newIndex - totalOriginal;
//       setTimeout(() => {
//         scrollToIndex(jumpToIndex, false);
//         setCurrentCenterIndex(jumpToIndex);
//       }, 100);
//     } else {
//       setCurrentCenterIndex(newIndex);
//     }
//   };

//   const scrollLeft = () => {
//     if (isScrolling) return;
//     setIsScrolling(true);
//     let newIndex = currentCenterIndex - 1;
//     scrollToIndex(newIndex);
//     setTimeout(() => {
//       const buffer = visibleCardCount === 1 ? 1 : 2;
//       if (newIndex <= buffer - 1) {
//         newIndex = totalOriginal + (newIndex - buffer + 1);
//         scrollToIndex(newIndex, false);
//       }
//       setCurrentCenterIndex(newIndex);
//       setIsScrolling(false);
//     }, 400);
//   };

//   const scrollRight = () => {
//     if (isScrolling) return;
//     setIsScrolling(true);
//     let newIndex = currentCenterIndex + 1;
//     scrollToIndex(newIndex);
//     setTimeout(() => {
//       const buffer = visibleCardCount === 1 ? 1 : 2;
//       const maxIndex = totalOriginal + buffer;
//       if (newIndex >= maxIndex + 1) {
//         newIndex = newIndex - totalOriginal;
//         scrollToIndex(newIndex, false);
//       }
//       setCurrentCenterIndex(newIndex);
//       setIsScrolling(false);
//     }, 400);
//   };

//   // Handle scroll to show/hide floating button
//   useEffect(() => {
//     const handleScroll = () => {
//       if (!triggerRef.current || !footerRef.current) return;

//       const triggerTop = triggerRef.current.offsetTop;
//       const footerTop = footerRef.current.offsetTop;
//       const scrollY = window.scrollY;
//       const windowHeight = window.innerHeight;

//       // Show button when user scrolls past the trigger point
//       // Hide button when user reaches the footer section
//       const shouldShow =
//         scrollY + windowHeight >= triggerTop &&
//         scrollY + windowHeight <= footerTop + 100;

//       setShowFloatingButton(shouldShow);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   // Scroll to top when component mounts
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   // get the title and summery , futureid
//   useEffect(() => {
//     const getStoryDetails = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/identity`
//         );
//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch comments:", errorData.detail);
//           return;
//         }

//         const data = await response.json();
//         console.log("this is the title data", data);
//         setTitleAndIdData(data.identity);
//         setTitle(
//           data.identity.selected_title ||
//             data.identity.title?.[0]?.title ||
//             "Untitled"
//         );

//         setFutureIdData({
//           title: data.identity.emerging_identity_title,
//           description: data.identity.emerging_identity?.[0] || "",
//         });
//       } catch (err) {
//         console.error("Error fetching comments:", err);
//       }
//     };
//     getStoryDetails();
//   }, []);

//   // get the openthreads
//   useEffect(() => {
//     const getSolutionNotAchieved = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/thread_if_solution_not_achieved`
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch comments:", errorData.detail);
//           return;
//         }

//         const data = await response.json();
//         console.log("Raw unresolved threads data:", data);

//         // ✅ First, access the nested array correctly
//         const threadGroups =
//           data.thread_if_not_achieved?.thread_if_not_achieved;

//         if (!Array.isArray(threadGroups)) {
//           console.error("Unexpected thread data structure:", threadGroups);
//           return;
//         }

//         // ✅ Get the last thread group
//         const lastGroup = threadGroups[threadGroups.length - 1];

//         if (lastGroup && Array.isArray(lastGroup.threads)) {
//           const latestThree = lastGroup.threads.slice(-3).map((thread) => ({
//             observation: thread["Grounded Observation"] || "",
//             contradiction:
//               thread["Unfinished Thread / Contradiction"] ||
//               thread.unfinished_thread ||
//               "",
//             punchline: thread["Introspective Punchline"] || "",
//           }));

//           console.log("Top 3 unresolved threads:", latestThree);
//           setUnresolvedThreads(latestThree);
//           setThreads(latestThree);
//         }
//       } catch (err) {
//         console.error("Error fetching comments:", err);
//       }
//     };
//     getSolutionNotAchieved();
//   }, []);

//   // getting the assurence staemnt and the deep questions
//   useEffect(() => {
//     const getAssurenceDetails = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/assurance_statement`
//         );
//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch comments:", errorData.detail);
//           return;
//         }

//         const data = await response.json();

//         const assurances = data.assurance_statement.assurance_statement;
//         const questions = data.assurance_statement.very_deep_question;

//         // Get last non-null assurance
//         const lastAssuranceObj = [...assurances]
//           .reverse()
//           .find((item) => item !== null);
//         const lastAssurance = lastAssuranceObj?.assurance_statement || "";

//         // Get last non-null deep question
//         const lastQuestionObj = [...questions]
//           .reverse()
//           .find((item) => item !== null);
//         const lastQuestion = lastQuestionObj?.deep_question || "";

//         setAssurenceAndDeepQuestion({
//           assurance: lastAssurance,
//           question: lastQuestion,
//         });
//       } catch (err) {
//         console.error("Error fetching comments:", err);
//       }
//     };
//     getAssurenceDetails();
//   }, []);

//   // get the stacks
//   // useEffect(() => {
//   //   const getStake = async () => {
//   //     try {
//   //       const response = await fetch(
//   //         `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/stake`
//   //       );
//   //       if (!response.ok) {
//   //         const errorData = await response.json();
//   //         console.error("Failed to fetch stake:", errorData.detail);
//   //         return;
//   //       }

//   //       const result = await response.json();
//   //       console.log("Raw Stake Data:", result);

//   //       // Flatten and categorize the data
//   //       const stakes = result.stake.stake.flatMap((item) => item.stakes);

//   //       const recoverableAll = stakes
//   //         .filter((s) => s.risk_level === "Repairable if acted on soon")
//   //         .map((s) => `${s.stake}: ${s.implication}`);

//   //       const criticalAll = stakes
//   //         .filter((s) => s.risk_level === "At risk of permanent loss")
//   //         .map((s) => `${s.stake}: ${s.implication}`);

//   //       // Keep only latest 3 (assuming latest means last 3 items from the array)
//   //       const recoverable = recoverableAll.slice(-3);
//   //       const critical = criticalAll.slice(-3);

//   //       setStakeData({
//   //         Recoverable: recoverable,
//   //         Critical: critical,
//   //       });
//   //     } catch (err) {
//   //       console.error("Error fetching stake data:", err);
//   //     }
//   //   };

//   //   getStake();
//   // }, [assurenceAndDeepQuestion]);

//   useEffect(() => {
//     const getStake = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/stake`
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch stake:", errorData.detail);
//           return;
//         }

//         const result = await response.json();
//         console.log("Raw Stake Data:", result);

//         const rawStakeList = result?.stake?.stake ?? [];

//         // Normalize all entries into a flat array of { stake, risk_level, implication }
//         const normalized = rawStakeList.flatMap((entry) => {
//           // Case 1: entry itself is a stake object
//           if (entry?.stake && entry?.risk_level && entry?.implication) {
//             return [
//               {
//                 stake: entry.stake,
//                 risk_level: entry.risk_level,
//                 implication: entry.implication,
//               },
//             ];
//           }

//           // Case 2: entry contains "stakes" or "stake" array
//           const nested = entry.stakes || entry.stake;
//           if (Array.isArray(nested)) {
//             return nested.map((item) => ({
//               stake: item.stake || item.label || "Unknown",
//               risk_level: item.risk_level || "Unknown",
//               implication: item.implication || "",
//             }));
//           }

//           return [];
//         });

//         const recoverable = normalized
//           .filter((s) => s.risk_level === "Recoverable")

//           .map((s) => `${s.stake}: ${s.implication}`)
//           .slice(-3); // latest 3

//         const critical = normalized
//           .filter((s) => s.risk_level !== "Recoverable")

//           .map((s) => `${s.stake}: ${s.implication}`)
//           .slice(-3); // latest 3

//         setStakeData({
//           Recoverable: recoverable,
//           Critical: critical,
//         });
//       } catch (err) {
//         console.error("Error fetching stake data:", err);
//       }
//     };

//     getStake();
//   }, []);

//   // get the barriers
//   useEffect(() => {
//     const getbarriers = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/barrier`
//         );
//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch barriers:", errorData.detail);
//           return;
//         }

//         const data = await response.json();

//         console.log("barriers", data);
//         const internalGroups = data?.barriers.internal_barrier;
//         const externalGroups = data?.barriers.external_barrier;

//         // Flatten internal barriers
//         const allInternal = internalGroups
//           .flatMap((group) => group.internal_barrier || [])
//           .filter(
//             (b) => b.label && !b.label.startsWith("None, explanation as:")
//           );

//         // Flatten external barriers
//         // Updated: Flatten external barriers and filter out "None"
//         const allExternal = externalGroups
//           .flatMap((group) => group.external_barrier || [])
//           .filter(
//             (b) =>
//               b.label &&
//               b.label !== "None" &&
//               !b.label.startsWith("None, explanation as:")
//           );

//         setAllBarriers({
//           internal: allInternal,
//           external: allExternal,
//         });

//         setRecentBarriers({
//           internal: allInternal.slice(-3),
//           external: allExternal.slice(-3),
//         });
//       } catch (err) {
//         console.error("Error fetching barriers:", err);
//       }
//     };

//     getbarriers();
//   }, []);

//   // getting the blind sports
//   useEffect(() => {
//     const getBlindSpots = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/blind_spots`
//         );
//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch blind spots:", errorData.detail);
//           return;
//         }

//         const data = await response.json();

//         // Flatten the nested blind_spots arrays
//         const flattened = data.blind_spots.blind_spots
//           .filter(Boolean)
//           .flatMap((entry) => entry.blind_spots || []);

//         setBlindSpots(flattened);
//       } catch (err) {
//         console.error("Error fetching blind spots:", err);
//       }
//     };

//     getBlindSpots();
//   }, []);

//   // getting the prapose climex
//   useEffect(() => {
//     const getPraposeClimex = async () => {
//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/proposed_climax`
//         );
//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch proposed climax:", errorData.detail);
//           return;
//         }

//         const data = await response.json();

//         // Filter out nulls and use the first valid hero_story
//         const validStories =
//           data.proposed_climax.proposed_climax.filter(Boolean);
//         if (validStories.length > 0) {
//           const lastStory = validStories[validStories.length - 1];
//           if (lastStory.hero_story) {
//             setHeroStory(lastStory.hero_story);
//           }
//         }
//       } catch (err) {
//         console.error("Error fetching proposed climax:", err);
//       }
//     };

//     getPraposeClimex();
//   }, []);

//   useEffect(() => {
//     const getAcitons = async () => {
//       try {
//         // const response = await fetch(
//         //   `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/6267ed35-1d67-4c7a-8bfd-aa284ab04b62/c71a1937-7d11-4ac5-bb01-18e5edd2f894/actions`
//         // );
//         const response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/actions`
//         );
//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch proposed climax:", errorData.detail);
//           return;
//         }

//         const data = await response.json();

//         console.log("action", data);

//         const rawActions = data.session_actions?.flatMap((session) =>
//           Object.values(session.actions || {})
//         );

//         if (rawActions.length === 0) {
//           setHasActions(false);
//           setActionsByFreq({ Daily: [], Weekly: [], Monthly: [] });
//           return;
//         }

//         // Group by frequency
//         const grouped = { Daily: [], Weekly: [], Monthly: [] };
//         rawActions.forEach((action) => {
//           const freq = action.frequency;
//           if (grouped[freq]) {
//             grouped[freq].push(action);
//           }
//         });

//         setActionsByFreq(grouped);
//         setHasActions(true);
//       } catch (err) {
//         console.error("Error fetching proposed climax:", err);
//       }
//     };

//     getAcitons();
//   }, []);

//   // get the other threads on click

//   const getThreadsBasedOnTab = async (tab) => {
//     setThreads([]);

//     if (tab === "Unresolved" && unresolvedThreads.length > 0) {
//       setThreads(unresolvedThreads);
//       return;
//     }

//     if (tab === "Unspoken" && unSpokenThreads.length > 0) {
//       setThreads(unSpokenThreads);
//       return;
//     }

//     if (tab === "Incomplete" && incompleteThreads.length > 0) {
//       setThreads(incompleteThreads);
//       return;
//     }

//     try {
//       let response = "";
//       if (tab === "Incomplete") {
//         response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/open_threads`
//         );
//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch comments:", errorData.detail);
//           return;
//         }

//         const data = await response.json();
//         console.log("this is open threads data", data);

//         // Get the last open_thread
//         const openThreadsArray = data.open_threads.open_threads;
//         const lastThreadGroup = openThreadsArray[openThreadsArray.length - 1];

//         if (lastThreadGroup && Array.isArray(lastThreadGroup.threads)) {
//           // Get the last 3 threads
//           const latestThree = lastThreadGroup.threads.slice(-3);

//           const valuesArray = latestThree.map((thread) => ({
//             observation: thread["Grounded Observation"] || "",
//             contradiction:
//               thread["Unfinished Thread / Contradiction"] ||
//               thread.unfinished_thread ||
//               "",
//             punchline: thread["Introspective Punchline"] || "",
//           }));

//           console.log("this is openthred need to be displayed", valuesArray);

//           setIncompleteThreads(valuesArray);
//           setThreads(valuesArray);
//         }
//       } else if (tab === "Unspoken") {
//         response = await fetch(
//           `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/thread_if_solution_not_clear`
//         );

//         if (!response.ok) {
//           const errorData = await response.json();
//           console.error("Failed to fetch comments:", errorData.detail);
//           return;
//         }

//         const data = await response.json();
//         console.log("Raw not-clear threads data:", data);

//         // ✅ Correctly access the nested thread array
//         const notClearThreadsArray =
//           data.thread_if_not_clear?.thread_if_not_clear;

//         if (!Array.isArray(notClearThreadsArray)) {
//           console.error(
//             "Unexpected structure in not-clear threads:",
//             notClearThreadsArray
//           );
//           return;
//         }

//         // ✅ Get the last group of threads
//         const lastThreadGroup =
//           notClearThreadsArray[notClearThreadsArray.length - 1];

//         if (lastThreadGroup && Array.isArray(lastThreadGroup.threads)) {
//           const lastThreeUnfinished = lastThreadGroup.threads
//             .slice(-3)
//             .map((thread) => ({
//               observation: thread["Grounded Observation"] || "",
//               contradiction:
//                 thread["Unfinished Thread / Contradiction"] ||
//                 thread.unfinished_thread ||
//                 "",
//               punchline: thread["Introspective Punchline"] || "",
//             }));

//           console.log("Last 3 unfinished (not clear):", lastThreeUnfinished);
//           setUnSpokenThreads(lastThreeUnfinished);
//           setThreads(lastThreeUnfinished);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching comments:", err);
//     }
//   };

//   useEffect(() => {
//     const load = async () => {
//       const d = await fetchData();

//       d.barriers = {
//         ...d.barriers,
//         options: {
//           Internal: recentBarriers.internal.map((b) => b.label),
//           External: recentBarriers.external.map((b) => b.label),
//         },
//         active: d.barriers?.active || "Internal",
//       };

//       setData(d);
//       setStakeTab(d.stake?.active || "");
//       setBarrierTab(d.barriers.active);
//       console.log("these are some barriers", d.barriers);
//     };

//     if (recentBarriers.internal.length || recentBarriers.external.length) {
//       load();
//     }
//   }, [recentBarriers]);

//   const getPreview = (text, wordLimit = 50) => {
//     const words = text.split(" ");
//     return words.length <= wordLimit
//       ? text
//       : words.slice(0, wordLimit).join(" ") + "...";
//   };

//   const handleOpenModal = (title, data, type) => {
//     setModalTitle(title);
//     setModalData(data);
//     setModalType(type); // 'blind_spots', 'barriers', etc.
//     setIsModalOpen(true);
//   };

//   // const handleNewChapter = (storyId) => {
//   //   setIsLoading(true);

//   //   console.log(selectedForStartReflection);
//   //   endAllRunningSessions();
//   // };

//   useEffect(() => {
//     if (!selectedForStartReflection) return;
//     console.log("this has to be the updated value", selectedForStartReflection);
//     handleNewChapter(); // selectedForStartReflection is now available
//   }, [selectedForStartReflection]);

//   const handleSelect = (item) => {
//     console.log(item);
//     setSelectedForStartReflection(item);
//     handleNewChapter(item);
//   };

//   useEffect(() => {
//     if (newChapter) {
//       handleNewChapter();
//     }
//   }, [newChapter]);

//   const handleNewChapter = () => {
//     setIsLoading(true);
//     endAllRunningSessions();
//   };

//   const endAllRunningSessions = async () => {
//     setIsLoadingData("All running conversations are being closed");
//     const coach = { coachName: "Eira", selectedTime: 21 };
//     try {
//       await fetch(
//         `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/end`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       // const exitSession = await res.json();
//       // console.log(exitSession);
//       console.log("Session Ended");
//       createSession(coach);
//     } catch (error) {
//       console.log("The session has ended:", error.message);
//     }
//   };

//   const createSession = async (coach) => {
//     const currentMood = "NO mood selecter for this chapter";
//     setIsLoadingData("Your new chapter is being created");
//     console.log("THIS IS NEW CHAPTER VALUE", newChapter);
//     try {
//       const queryParam = `?newChapter=${(!newChapter).toString()}`;
//       const res = await fetch(
//         `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/create/${coach.coachName}/${coach.selectedTime}/Sad/${storyId}${queryParam}`,
//         {
//           method: "GET",
//         }
//       );
//       console.log("Called continue session API with story_id:", storyId);

//       if (!res.ok) {
//         throw new Error("Failed to create session");
//       }

//       const createSession = await res.json();
//       console.log(createSession);
//       if (newChapter) {
//         navigate("/chat");
//         console.log(storyId, "story id is from start new chapter");
//       } else {
//         addFirstResponse(createSession.session_id);
//       }

//       // addFirstResponse(createSession.session_id);

//       console.log("sessio will be created in a min");
//     } catch (error) {
//       console.error("Error creating session:", error);
//     }
//   };

//   const addFirstResponse = async (sessionID) => {
//     setIsLoadingData("Adding your first step");
//     const payload = {
//       coachee_response: selectedForStartReflection,
//       focus_popup_required: 0,
//       record_from_focus_popup: 0,
//       selected_focus_choice: 1,
//       conversation_summary: "",
//       regenerate_with_intention: false,
//       focus_options: "",
//       alternate_focus_hypothesis: "",
//     };
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/${sessionID}/step`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );
//       const data = await response.json();
//       console.log("This is the data", data);
//       if (response.ok) {
//         navigate("/chat");
//         console.log(storyId, "story id is from start new chapter");
//       }
//     } catch (error) {
//       console.error("Error creating session:", error);
//     }
//   };

//   // const handleSelect = (item) => {
//   //   setSelectedForStartReflection(item);
//   // };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleSave = async () => {
//     setIsEditing(false);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_selected_title`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             userid: user.user_id,
//             story_id: storyId,
//             chapter_id: titleAndIdData.chapter_id, // make sure this exists in your state
//             title: title,
//           }),
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error("Failed to update title:", errorData.detail || errorData);
//         return;
//       }

//       const result = await response.json();
//       console.log("Title updated successfully:", result);
//     } catch (error) {
//       console.error("Error updating title:", error);
//     }
//   };

//   const handleFutureIdSave = async () => {
//     setIsEditingFutureId(false);

//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_future_id`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             userid: user.user_id,
//             story_id: storyId,
//             future_identity: futureIdData.description,
//             future_identity_title: futureIdData.title,
//           }),
//         }
//       );

//       if (!res.ok) throw new Error("Failed to update Future ID");

//       const data = await res.json();
//       console.log("Future ID updated:", data);
//     } catch (error) {
//       console.error("Error updating Future ID:", error);
//     }
//   };

//   const isNoExternalBarrier =
//     barrierTab === "External" &&
//     (data?.barriers.options[barrierTab].length === 0 ||
//       data?.barriers.options[barrierTab][0] ===
//         "No external barrier is present");

//   // if (!assurenceAndDeepQuestion)
//   //   return (
//   //     <div className="fixed inset-0 z-50 bg-white/60 backdrop-blur-sm flex items-center justify-center pointer-events-auto">
//   //       <div className="flex flex-col items-center justify-center space-y-4">
//   //         <div className="w-16 h-16 border-4 border-gray-300 border-t-[#54B0AF] rounded-full animate-spin"></div>
//   //       </div>
//   //     </div>
//   //   );

//   return (
//     <div className="w-full p-6 font-sans text-gray-800 bg-[#F2F2F2] min-h-screen relative">
//       <div className="container mx-auto">
//         {/* Header */}
//         <div className="flex justify-between items-center mb-8 mt-4">
//           <button
//             // onClick={() => navigate("/workspace")}
//             onClick={() => {
//               navigate("/workspace", { state: { storyId } });
//               console.log("Back button is clicked");
//             }}
//             className="flex items-center text-xl lg:text-2xl text-[#323232] font-gotham font-medium hover:text-gray-800"
//           >
//             <ChevronLeft className="w-4 h-4 mr-1 text-xl lg:text-2xl" />
//             Back
//           </button>
//           <div className="hidden md:flex items-center group relative">
//             {isEditing ? (
//               <input
//                 type="text"
//                 autoFocus
//                 value={title}
//                 onChange={(e) => setTitle(e.target.value)}
//                 onBlur={() => setIsEditing(false)}
//                 onKeyDown={(e) => e.key === "Enter" && handleSave()}
//                 className="text-xl md:text-3xl lg:text-4xl font-bold font-gotham text-[#323232] border-b border-gray-400 outline-none bg-transparent px-1 w-full min-w-[36rem] overflow-hidden"
//                 style={{ height: "auto" }}
//               />
//             ) : (
//               <h1
//                 onClick={() => setIsEditing(true)}
//                 className="text-xl md:text-3xl lg:text-[32px] font-bold font-gotham text-[#323232] px-3 md:px-0 cursor-pointer group-hover:underline transition duration-200 ease-in-out"
//               >
//                 {title}
//               </h1>
//             )}

//             {!isEditing && (
//               <button
//                 onClick={() => setIsEditing(true)}
//                 className="absolute -right-16 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out w-20 h-20 flex items-center justify-center"
//               >
//                 <PencilLine className="w-10 h-10 text-gray-500 hover:text-gray-700" />
//               </button>
//             )}
//           </div>

//           <div className="flex items-center bg-white  rounded-full shadow-sm">
//             {/* <div className="flex items-center bg-white px-3 py-2 rounded-full shadow-sm"> */}
//             {/* <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
//             <span className="text-sm font-medium text-[#323232]">
//               {data?.mood}
//             </span> */}
//           </div>
//         </div>

//         <div className="relative w-full px-3 md:px-0 mb-3 flex justify-center items-center md:hidden">
//           {isEditing ? (
//             <input
//               type="text"
//               autoFocus
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//               onBlur={() => setIsEditing(false)}
//               onKeyDown={(e) => e.key === "Enter" && handleSave()}
//               className="text-xl md:text-3xl lg:text-[32px] font-bold font-gotham text-[#323232] border-b border-gray-400 outline-none bg-transparent w-full max-w-full"
//             />
//           ) : (
//             <h1
//               onClick={() => setIsEditing(true)}
//               className="text-xl md:text-3xl lg:text-4xl font-bold font-gotham text-[#323232] w-full cursor-pointer group-hover:underline transition duration-200 ease-in-out"
//             >
//               {title}
//             </h1>
//           )}

//           {!isEditing && (
//             <button
//               onClick={() => {
//                 setIsEditing(true);
//               }}
//               className="absolute right-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out"
//             >
//               <Pencil className="w-4 h-4 text-[#323232] hover:text-gray-800" />
//             </button>
//           )}
//         </div>

//         {/* Intro Section with Panda */}
//         <div className="flex flex-col lg:flex-row items-start gap-6 mb-8 mt-3 md:mt-0">
//           {/* Text Container */}
//           <div className="flex-1 rounded-2xl bg-white p-6 sm:p-8 min-h-[160px] flex items-center justify-center">
//             <p className="text-[#666666] text-sm sm:text-base lg:text-xl font-gotham font-medium leading-relaxed text-center lg:text-left">
//               {titleAndIdData.conversation_history}
//             </p>
//           </div>

//           {/* Image Container */}
//           <div className="w-full sm:w-1/2 lg:w-[20%] min-h-[160px] h-36 bg-[#54B0AF] rounded-2xl flex items-center justify-center">
//             <img
//               src={pandaImg}
//               alt="Panda"
//               className="h-full max-h-80 object-containx"
//             />
//           </div>
//         </div>

//         {/* Future ID and Tabs Section */}
//         <div className="flex flex-col md:flex-row items-stretch gap-4 md:gap-6 mb-8">
//           <div className="bg-white p-6 rounded-2xl shadow-sm w-full md:max-w-xs group relative">
//             {/* Notch with edit button */}
//             <div className="flex justify-center mb-3 relative">
//               <div className="w-12 h-3 bg-gray-300 rounded-full"></div>

//               {!isEditingFutureId && (
//                 <button
//                   onClick={() => setIsEditingFutureId(true)}
//                   className="absolute right-0 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out w-8 h-8 flex items-center justify-center"
//                 >
//                   <PencilLine className="w-5 h-5 text-[#323232] hover:text-gray-800" />
//                 </button>
//               )}
//             </div>

//             {isEditingFutureId ? (
//               <>
//                 <textarea
//                   autoFocus
//                   value={futureIdData.title}
//                   onChange={(e) =>
//                     setFutureIdData({ ...futureIdData, title: e.target.value })
//                   }
//                   className="text-2xl font-bold mb-4 text-center font-gotham w-full border-b border-gray-400"
//                 />
//                 <div className="flex justify-center mb-4">
//                   <div className="w-40 h-40 bg-gray-100 rounded-full flex items-center justify-center">
//                     <img src={futImg} alt="" />
//                   </div>
//                 </div>
//                 <textarea
//                   value={futureIdData.description}
//                   onChange={(e) =>
//                     setFutureIdData({
//                       ...futureIdData,
//                       description: e.target.value,
//                     })
//                   }
//                   className="text-base md:text-lg font-gotham font-medium text-[#1D1D1D] border-b border-gray-400 outline-none bg-transparent px-1 w-full overflow-hidden resize-none"
//                   rows={4}
//                 />
//                 <button
//                   className="mt-4 px-4 py-2 bg-[#54B0AF] text-white rounded-xl"
//                   onClick={handleFutureIdSave}
//                 >
//                   Save
//                 </button>
//               </>
//             ) : (
//               <>
//                 <h3 className="text-xl md:text-2xl font-bold mb-4 text-center font-gotham cursor-pointer">
//                   {futureIdData.title || "Future ID"}
//                 </h3>
//                 <div className="flex justify-center mb-4">
//                   <div className="w-40 h-40 bg-gray-100 rounded-full flex items-center justify-center">
//                     <img src={futImg} alt="" />
//                   </div>
//                 </div>
//                 <div className="text-base font-gotham font-medium text-[#666666] cursor-pointer transition duration-200 ease-in-out px-1">
//                   {futureIdData.description}
//                 </div>
//               </>
//             )}
//           </div>

//           {/* Tabs Section */}
//           <div className="flex-1 bg-white rounded-2xl shadow-sm">
//             {/* Tab Navigation */}
//             <div className="flex border-b-[20px] gap-2 md:gap-4 bg-[#F2F2F2]  border-gray-100">
//               {["Unresolved", "Unspoken", "Incomplete"].map((t) => (
//                 <button
//                   key={t}
//                   onClick={() => {
//                     console.log(t);
//                     setTab(t);
//                     getThreadsBasedOnTab(t);
//                   }}
//                   className={`flex-1 px-4 py-3 text-xs font-bold font-gotham md:text-lg lg:text-2xl rounded-xl ${
//                     tab === t
//                       ? "bg-[#54B0AF] text-white"
//                       : "text-[#1D1D1D] hover:text-gray-800 bg-white"
//                   }`}
//                 >
//                   {t}
//                 </button>
//               ))}
//             </div>
//             {/* Tab Content */}
//             <div className="p-3 sm:p-6 items-stretch bg-white rounded-2xl">
//               <div className="mb-4">
//                 <h4 className="text-lg md:text-2xl text-[#323232] font-bold font-gotham mb-2">
//                   {tab}
//                 </h4>
//                 <p className="text-sm md:text-[16px] text-[#666666] font-gotham font-medium">
//                   Hints were there, but the real topic never surfaced. These are
//                   the threads waiting to be named.
//                 </p>
//               </div>

//               <div className="space-y-3 overflow-hidden h-auto">
//                 {threads.map((item, idx) => {
//                   const isSelected = selectedForStartReflection === item;

//                   return (
//                     <div
//                       key={idx}
//                       className={`flex items-center justify-between text-justify p-1 sm:p-4 border-b-2 border-[#F5F5F5] cursor-pointer group rounded-md transition-all duration-200 ease-in-out`}
//                     >
//                       {/* Left side - Item text */}
//                       <span
//                         className={`text-sm md:text-lg font-normal w-full font-gotham text-[#323232] transform transition-all duration-300 ease-in-out
//                   ${
//                     isSelected
//                       ? "-translate-x-20"
//                       : "group-hover:-translate-x-20"
//                   }`}
//                       >
//                         {/* {item} */}
//                         <p>
//                           {item.observation} {item.contradiction}{" "}
//                           <span className="text-[#54A0A9]">
//                             {item.punchline}
//                           </span>
//                         </p>
//                       </span>

//                       {/* Right side - icon or text + icon on hover */}
//                       <div className="flex items-center space-x-1 sm:space-x-2">
//                         {/* Default ChevronRight when not hovered or selected */}
//                         <ChevronRight
//                           className={`w-6 h-6 transition-opacity duration-150 ml-1 ease-in-out text-gray-400
//                             ${isSelected ? "hidden" : "group-hover:hidden"}`}
//                         />

//                         {/* Show on hover or when selected */}
//                         <div
//                           className={`flex flex-col sm:flex-row items-center gap-1 text-[10px] sm:text-sm text-[#323232] font-medium opacity-0 group-hover:opacity-100 ${
//                             isSelected ? "opacity-100" : ""
//                           } transition-opacity duration-200`}
//                           onClick={() => {
//                             setSelectedForStartReflection(item.punchline);
//                           }}
//                         >
//                           <span className="text-[#54B0AF]  underline">
//                             Continue Untangling
//                           </span>
//                           <div className="w-6 h-6 flex items-center justify-center bg-gray-200 rounded-full">
//                             <NotebookPen className="w-3.5 h-3.5 text-[#323232]" />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Trigger point for floating button - This is where the button should start appearing */}
//         <div ref={triggerRef} className="flex items-center justify-start p-6">
//           <div className="text-start max-w-full w-full">
//             <h1 className="text-2xl md:text-[48px] font-bold text-[#E3E3E3] mb-3 leading-7 md:leading-[3rem] font-gotham">
//               {assurenceAndDeepQuestion.assurance}
//             </h1>
//             <div className="flex items-center justify-between mt-5">
//               <p className="text-sm md:text-xl text-[#666666] font-medium leading-relaxed">
//                 {assurenceAndDeepQuestion.question}
//               </p>

//               <button
//                 title="Let’s Reflect"
//                 onClick={() => {
//                   setSelectedForStartReflection(
//                     assurenceAndDeepQuestion.question
//                   );
//                 }}
//                 className="ml-4 flex items-center gap-2 font-medium text-sm md:text-base text-[#54B0AF] underline"
//               >
//                 <div className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full">
//                   <NotebookPen className="w-5 h-5" />
//                 </div>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Stake and Barriers Section */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 font-gotham py-6">
//           {/* My Barriers */}
//           <div className="bg-white p-6 rounded-2xl shadow-sm flex flex-col min-h-[300px] relative">
//             <div>
//               <h3 className="text-lg md:text-2xl text-[#1D1D1D] font-gotham font-bold mb-4">
//                 My Barriers
//               </h3>

//               <p className="text-sm md:text-xl font-medium font-gotham text-[#888888] mb-4 mt-4">
//                 Forces causing friction or holding you back.
//               </p>

//               <div className="flex gap-4 mb-4 bg-[#54B0AF] rounded-2xl p-1 mt-5">
//                 <button
//                   onClick={() => setBarrierTab("Internal")}
//                   className={`px-4 py-2 w-full rounded-[20px] text-sm md:text-xl font-medium font-gotham transition-all duration-150 ${
//                     barrierTab === "Internal"
//                       ? "bg-white text-[#323232]"
//                       : "text-[#FFFFFF]"
//                   }`}
//                 >
//                   Internal barrier
//                 </button>
//                 <button
//                   onClick={() => setBarrierTab("External")}
//                   className={`px-4 py-2 w-full rounded-[14px] text-sm md:text-lg font-medium font-gotham transition-all duration-150 ${
//                     barrierTab === "External"
//                       ? "bg-white text-[#323232]"
//                       : "text-[#FFFFFF]"
//                   }`}
//                 >
//                   External barrier
//                 </button>
//               </div>
//             </div>

//             <div className="flex-grow">
//               <div className="flex-grow overflow-hidden relative">
//                 <div className="max-h-[250px] overflow-y-auto pr-1 custom-scrollbar"></div>
//                 <ul className="space-y-2 mb-4">
//                   {data?.barriers.options[barrierTab]?.length === 0 ? (
//                     <p className="text-[#888888] text-sm md:text-xl font-gotham font-medium">
//                       {barrierTab === "Internal"
//                         ? "No internal barriers found."
//                         : "No external barriers found."}
//                     </p>
//                   ) : (
//                     data?.barriers.options[barrierTab]
//                       ?.slice()
//                       .reverse()
//                       .map((point, idx) => {
//                         const isExpanded = activeBarrierIdx === idx;
//                         const barrierData = [
//                           ...allBarriers.internal,
//                           ...allBarriers.external,
//                         ].find((b) => b.label === point);

//                         return (
//                           <li
//                             key={idx}
//                             onMouseEnter={() => {
//                               if (!isNoExternalBarrier) {
//                                 setActiveBarrierIdx(idx);
//                               }
//                             }}
//                             onMouseLeave={() => {
//                               if (!isNoExternalBarrier) {
//                                 setActiveBarrierIdx(null);
//                               }
//                             }}
//                             className={`flex flex-col text-sm md:text-[16px] font-gotham font-medium rounded-xl p-2 transition-all ${
//                               !isNoExternalBarrier ? "cursor-pointer group" : ""
//                             }`}
//                           >
//                             <div className="flex items-center justify-between">
//                               <span className="text-sm md:text-xl font-medium text-[#484848] truncate">
//                                 {point}
//                               </span>

//                               {!isNoExternalBarrier && (
//                                 <div
//                                   className={`flex items-center gap-1 text-sm text-[#323232] font-medium transition-opacity duration-300 ${
//                                     selectedForStartReflection === point
//                                       ? "opacity-100"
//                                       : "opacity-0 group-hover:opacity-100"
//                                   }`}
//                                   onClick={() => {
//                                     // console.log(
//                                     //   "Clicked label:",
//                                     //   barrierData.label
//                                     // );
//                                     // console.log(
//                                     //   "Explanation:",
//                                     //   barrierData.explanation
//                                     // );
//                                     setSelectedForStartReflection(
//                                       barrierData.label
//                                     );
//                                   }}
//                                 >
//                                   <span className="text-[#54B0AF] underline whitespace-nowrap">
//                                     Let's Address
//                                   </span>
//                                   <div className="w-6 h-6 flex items-center justify-center bg-gray-200 rounded-full">
//                                     <NotebookPen className="w-3.5 h-3.5 text-[#323232]" />
//                                   </div>
//                                 </div>
//                               )}
//                               {!isNoExternalBarrier && (
//                                 <ChevronRight
//                                   className={`w-4 h-4 transition-opacity duration-150 ease-in-out text-gray-400
//                             ${
//                               selectedForStartReflection === point
//                                 ? "hidden"
//                                 : "group-hover:hidden"
//                             }`}
//                                 />
//                               )}
//                             </div>

//                             <AnimatePresence initial={false}>
//                               {isExpanded && barrierData?.explanation && (
//                                 <motion.div
//                                   key="explanation"
//                                   initial={{ opacity: 0, height: 0 }}
//                                   animate={{ opacity: 1, height: "auto" }}
//                                   exit={{ opacity: 0, height: 0 }}
//                                   transition={{ duration: 0.3 }}
//                                   className="overflow-hidden"
//                                 >
//                                   <p className="text-[#666] text-base font-medium p-2">
//                                     {barrierData.explanation}
//                                   </p>
//                                 </motion.div>
//                               )}
//                             </AnimatePresence>
//                           </li>
//                         );
//                       })
//                   )}
//                 </ul>
//               </div>
//             </div>

//             <button
//               className="flex items-center text-sm md:text-[18px] text-[#1D1D1D] font-medium hover:text-gray-800 mt-10"
//               onClick={() =>
//                 handleOpenModal(
//                   "All Barriers",
//                   [...allBarriers.internal, ...allBarriers.external],
//                   "barriers"
//                 )
//               }
//             >
//               <span className="font-medium underline">View all</span>
//               <FiArrowRight className="w-4 h-4" />
//             </button>

//             <img
//               src={emoji1}
//               alt=""
//               className="w-10 h-10 absolute bottom-5 right-5"
//             />
//           </div>

//           {/* My Stake */}

//           <div className="bg-white p-6 rounded-2xl shadow-sm flex flex-col min-h-[300px] relative">
//             <div>
//               <div className="flex items-center justify-between mb-4">
//                 <h3 className="text-lg md:text-2xl text-[#1D1D1D] font-bold font-gotham">
//                   My Stake
//                 </h3>
//                 <div className="w-8 h-8 bg-[#FFE5E5] rounded-full flex justify-center items-center">
//                   <div className="w-2.5 h-2.5 bg-[#FF0000B2] rounded-full"></div>
//                 </div>
//               </div>

//               <p className="text-sm md:text-xl text-[#888888] font-medium font-gotham mb-4">
//                 Possible outcomes if you don't act in time.
//               </p>

//               <div className="flex gap-4 mb-4 bg-[#54B0AF] rounded-[20px] mt-5 p-1">
//                 {["Recoverable", "Critical"].map((key) => (
//                   <button
//                     key={key}
//                     onClick={() => setStakeTab(key)}
//                     className={`px-4 py-2 w-full rounded-[14px] text-sm md:text-xl font-medium font-gotham transition-all duration-150 ${
//                       stakeTab === key
//                         ? "bg-white text-[#323232]"
//                         : "text-[#FFFFFF]"
//                     }`}
//                   >
//                     {key}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div className="flex-grow">
//               <ul className="space-y-2 mb-4">
//                 {stakeData[stakeTab]?.length > 0 ? (
//                   stakeData[stakeTab]?.map((point, idx) => {
//                     const [stakeName, implication] = point.split(": ");
//                     const isExpanded = activeStakeIdx === idx;

//                     return (
//                       <li
//                         key={idx}
//                         onMouseEnter={() => setActiveStakeIdx(idx)}
//                         onMouseLeave={() => setActiveStakeIdx(null)}
//                         className="flex flex-col text-sm md:text-[16px] font-gotham font-medium rounded-xl p-2 transition-all cursor-pointer group"
//                       >
//                         <div className="flex items-center justify-between">
//                           <span className="text-sm md:text-xl font-medium text-[#484848] truncate">
//                             {stakeName}
//                           </span>

//                           <div
//                             className={`flex items-center gap-1 text-sm text-[#323232] font-medium transition-opacity duration-300 ${
//                               selectedForStartReflection === stakeName
//                                 ? "opacity-100"
//                                 : "opacity-0 group-hover:opacity-100"
//                             }`}
//                           >
//                             <button
//                               onClick={() => {
//                                 setSelectedForStartReflection(implication);
//                                 // call your reflection handler here
//                               }}
//                               className="text-[#54B0AF] underline whitespace-nowrap"
//                             >
//                               Let's Address
//                             </button>
//                             <div className="w-6 h-6 flex items-center justify-center bg-gray-200 rounded-full">
//                               <NotebookPen className="w-3.5 h-3.5 text-[#323232]" />
//                             </div>
//                           </div>

//                           <ChevronRight
//                             className={`w-4 h-4 transition-opacity duration-150 ease-in-out text-gray-400
//                             ${
//                               selectedForStartReflection === point
//                                 ? "hidden"
//                                 : "group-hover:hidden"
//                             }`}
//                           />
//                         </div>

//                         <AnimatePresence initial={false}>
//                           {isExpanded && implication && (
//                             <motion.div
//                               key="implication"
//                               initial={{ opacity: 0, height: 0 }}
//                               animate={{ opacity: 1, height: "auto" }}
//                               exit={{ opacity: 0, height: 0 }}
//                               transition={{ duration: 0.3 }}
//                               className="overflow-hidden"
//                             >
//                               <p className="text-[#666] font-medium p-2">
//                                 {implication}
//                               </p>
//                             </motion.div>
//                           )}
//                         </AnimatePresence>
//                       </li>
//                     );
//                   })
//                 ) : (
//                   <p className="text-[#888888] text-sm md:text-xl font-gotham font-medium">
//                     No {stakeTab.toLowerCase()} stakes found.
//                   </p>
//                 )}
//               </ul>
//             </div>

//             <button
//               className="flex items-center text-sm md:text-xl text-[#1D1D1D] font-gotham font-medium hover:text-gray-800 mt-10"
//               onClick={() => {
//                 const transformedStakeData = Object.entries(stakeData).flatMap(
//                   ([riskType, stakesArray]) =>
//                     stakesArray.map((stakeItem) => {
//                       const [stakeName, implication] = stakeItem.split(": ");
//                       return { riskType, stakeName, implication };
//                     })
//                 );

//                 handleOpenModal(
//                   "All Stakes",
//                   [
//                     ...stakeData.Recoverable.map((item) => ({
//                       stakeName: item.split(":")[0],
//                       implication: item.split(":")[1],
//                       riskType: "Recoverable",
//                     })),
//                     ...stakeData.Critical.map((item) => ({
//                       stakeName: item.split(":")[0],
//                       implication: item.split(":")[1],
//                       riskType: "Critical",
//                     })),
//                   ],
//                   "stakes"
//                 );
//               }}
//             >
//               <span className="font-medium underline">View all</span>
//               <FiArrowRight className="w-4 h-4" />
//             </button>

//             <img
//               src={emoji2}
//               alt=""
//               className="w-10 h-10 absolute bottom-5 right-5"
//             />
//           </div>
//         </div>

//         {/* Blind Spots Section */}
//         <div className="py-6">
//           <div className="flex flex-col items-center justify-center">
//             <h3 className="text-lg md:text-xl lg:text-2xl text-[#1D1D1D] font-bold font-gotham mb-2">
//               My Blind Spots
//             </h3>
//             <p className="text-sm md:text-xl text-[#888888] font-gotham font-medium mb-2 sm:mb-6 w-[60%] mt-4 text-center md:leading-7 leading-6">
//               Blind spots are habits or patterns you don't notice, but they
//               quietly shape your decisions. Not seen, but strongly felt.
//             </p>
//           </div>

//           <div className="flex justify-between items-center mt-2 sm:mt-4">
//             <div className="w-full max-w-full mx-auto p-1">
//               <div className="relative flex items-center justify-center py-4">
//                 {/* Left Arrow */}
//                 <button
//                   onClick={goToPrevious}
//                   className="absolute left-0 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow duration-200"
//                 >
//                   <ChevronLeft className="w-6 h-6 text-gray-600" />
//                 </button>

//                 <div className="flex justify-center items-start w-full max-w-full overflow-hidden py-3">
//                   <div
//                     className="flex gap-4"
//                     style={{
//                       transform: `translateX(${animationOffset}px)`,
//                       transition: isAnimating
//                         ? "transform 0.4s ease-in-out"
//                         : "none",
//                     }}
//                   >
//                     {getVisibleCards().map((card, idx) => {
//                       const { position } = card;
//                       const isCenter = position === 0;
//                       const isSide = Math.abs(position) === 1;
//                       const isEdge = Math.abs(position) === 2;

//                       let scale = 1;
//                       let opacity = 1;
//                       let translateX = 0;

//                       if (isSide) {
//                         scale = 0.95;
//                         opacity = 0.5;
//                       } else if (isEdge) {
//                         scale = 0.9;
//                         opacity = 0.25;
//                         translateX = position === -2 ? 5 : -5;
//                       }

//                       const labelSize = isCenter
//                         ? "text-lg md:text-xl"
//                         : isSide
//                         ? "text-base"
//                         : "text-base";
//                       const explanationSize = isCenter
//                         ? "text-sm md:text-lg"
//                         : isSide
//                         ? "text-sm"
//                         : "text-sm";

//                       return (
//                         <div
//                           key={`${card.index}-${idx}`}
//                           className="bg-white rounded-[20px] shadow-md p-6 relative"
//                           style={{
//                             width: isCenter ? "300px" : "270px",
//                             minWidth: isCenter ? "320px" : "280px",
//                             height: isCenter
//                               ? "360px"
//                               : isEdge
//                               ? "300px"
//                               : "330px",
//                             flexShrink: 0,
//                             transform: `scale(${scale}) translateX(${translateX}px)`,
//                             opacity,
//                             transition: "all 0.5s ease-in-out",
//                           }}
//                         >
//                           <div className="h-full flex flex-col justify-between overflow-hidden">
//                             {/* Title */}
//                             <div
//                               className={`font-bold mb-2 text-[#1D1D1D] font-gotham break-words whitespace-normal leading-tight ${labelSize}`}
//                             >
//                               {card.label}
//                             </div>

//                             {/* Fixed Button */}
//                             {isCenter && (
//                               <button
//                                 title="Let’s Reflect"
//                                 onClick={() => {
//                                   setSelectedForStartReflection(card.label);
//                                 }}
//                                 className={`absolute top-2 right-2 flex items-center gap-2 font-medium ${
//                                   isCenter ? "text-sm md:text-base" : "text-xs"
//                                 } text-[#54B0AF] underline`}
//                               >
//                                 <div className="w-7 h-7 flex items-center justify-center bg-gray-100 rounded-full">
//                                   <NotebookPen className="w-5 h-5" />
//                                 </div>
//                               </button>
//                             )}

//                             {/* Explanation */}
//                             <div
//                               className={`font-gotham font-medium text-[#323232] break-words leading-relaxed overflow-hidden ${explanationSize}`}
//                               style={{
//                                 flexGrow: 1,
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                                 display: "-webkit-box",
//                                 WebkitLineClamp: isCenter ? 5 : isSide ? 4 : 3,
//                                 WebkitBoxOrient: "vertical",
//                               }}
//                             >
//                               {card.explanation}
//                             </div>
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                 </div>

//                 {/* Mobile View: Show only center card */}
//                 <div className="md:hidden w-full flex justify-center px-4">
//                   <div className="bg-white rounded-[20px] shadow-md p-6 w-80 h-64">
//                     <div className="h-full flex flex-col justify-start">
//                       <div className="font-bold mb-4 text-[#1D1D1D] text-lg">
//                         {extendedBlindSpots[currentIndex]?.label}
//                       </div>
//                       <div className="text-sm text-[#323232]">
//                         {extendedBlindSpots[currentIndex]?.explanation}
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Right Arrow */}
//                 <button
//                   onClick={goToNext}
//                   className="absolute right-0 z-10 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:shadow-xl transition-shadow duration-200"
//                 >
//                   <ChevronRight className="w-6 h-6 text-gray-600" />
//                 </button>
//               </div>

//               {/* View All Link Button */}
//               <div className="flex justify-center mt-4">
//                 <button
//                   className="flex items-center text-sm md:text-xl text-[#1D1D1D] font-gotham font-medium hover:text-gray-900 transition-colors duration-200"
//                   onClick={() =>
//                     handleOpenModal(
//                       "All Blind Spots",
//                       blindSpots,
//                       "blind_spots"
//                     )
//                   }
//                 >
//                   <span className="font-medium underline">View all</span>
//                   <FiArrowRight className="w-4 h-4" />
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="py-5">
//           <div
//             className={`max-w-full w-full mx-auto flex flex-col ${
//               hasActions ? "md:flex-row" : "items-center"
//             } gap-5`}
//           >
//             {/* Left Card */}
//             <div
//               className={`w-full ${
//                 hasActions ? "md:w-[50%]" : "md:w-[60%]"
//               } bg-gradient-to-b from-[#FFFFFF] to-[#D7EDED] rounded-xl p-6 shadow-sm border border-gray-200 flex flex-col justify-between min-h-[300px]`}
//             >
//               {/* Header with sparkle icons */}
//               <div className="flex items-center justify-center gap-3 mb-4">
//                 <img src={stars} alt="" className="rotate-180" />
//                 <h2 className="text-base md:text-2xl font-bold font-gotham text-[#1D1D1D] ">
//                   Where This Could Go
//                 </h2>
//                 <img src={stars} alt="" />
//               </div>

//               {/* Main content */}
//               <p className="leading-relaxed mb-6 text-[#222222] px-4 md:px-12 text-sm md:text-lg lg:text-xl font-gotham font-medium">
//                 {isExpanded ? heroStory : getPreview(heroStory)}
//               </p>

//               {/* Read more button */}
//               <div className="text-center">
//                 {heroStory && (
//                   <div className="text-center">
//                     <button
//                       onClick={() =>
//                         handleOpenModal(
//                           "Where This Could Go",
//                           [heroStory],
//                           "hero"
//                         )
//                       }
//                       className="text-[#1D1D1D] font-gotham text-sm md:text-xl font-medium underline hover:text-gray-900 transition-colors"
//                     >
//                       Read more
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Right Card */}
//             {hasActions && (
//               <div className="w-full md:w-[50%] bg-white rounded-xl p-6 shadow-sm border border-gray-200 flex flex-col justify-between min-h-[300px]">
//                 <div>
//                   <h3 className="text-base md:text-2xl font-bold font-gotham text-[#1D1D1D] mb-4 mt-2">
//                     My Actions
//                   </h3>

//                   {/* Tabs */}
//                   <div className="flex gap-4 mb-4 bg-[#54B0AF] rounded-[20px] mt-5 p-1 w-full">
//                     {actionsTabs.map((tab) => (
//                       <button
//                         key={tab}
//                         onClick={() => setActiveTab(tab)}
//                         className={`px-4 py-2 w-1/3 rounded-[14px] text-sm md:text-xl font-medium font-gotham transition-all duration-150 ${
//                           activeTab === tab
//                             ? "bg-white text-[#323232]"
//                             : "text-[#FFFFFF]"
//                         }`}
//                       >
//                         {tab}
//                       </button>
//                     ))}
//                   </div>

//                   {/* Action List */}
//                   <ul className="space-y-2 mt-2">
//                     {actionsByFreq[activeTab]?.length > 0 ? (
//                       actionsByFreq[activeTab].map((action, idx) => (
//                         <li
//                           key={idx}
//                           className="flex items-center justify-between text-sm md:text-[16px] font-gotham font-medium cursor-pointer rounded-md py-1 px-2 transition-all group hover:bg-gray-100"
//                         >
//                           <div className="flex items-start gap-3">
//                             <span className="w-2 h-2 bg-[#484848] rounded-full mt-1 flex-shrink-0"></span>
//                             <span className="text-[#484848] font-medium font-gotham text-base">
//                               {action.action}
//                             </span>
//                           </div>

//                           <div className="flex items-center gap-2 text-sm text-[#323232] font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//                             <button
//                               // onClick={() => handleMarkDone(action)}
//                               className="text-[#54B0AF] underline"
//                             >
//                               Mark It As Done
//                             </button>
//                             <div
//                               className="w-6 h-6 flex items-center justify-center bg-gray-200 rounded-full"
//                               // onClick={() => handleDelete(action)}
//                             >
//                               <Trash className="w-3.5 h-3.5 text-[#323232]" />
//                             </div>
//                           </div>
//                         </li>
//                       ))
//                     ) : (
//                       <p className="text-sm text-gray-500 font-gotham font-medium px-2">
//                         No actions found for {activeTab}.
//                       </p>
//                     )}
//                   </ul>
//                 </div>

//                 <div className="flex justify-center mt-4">
//                   <button
//                     className="flex items-center text-sm md:text-xl text-[#1D1D1D] font-gotham font-medium hover:text-gray-900 transition-colors duration-200"
//                     onClick={() => {
//                       console.log(actionsByFreq);
//                       handleOpenModal("All Action", actionsByFreq, "action");
//                     }}
//                   >
//                     <span className="font-medium underline">View all</span>
//                     <FiArrowRight className="w-4 h-4" />
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Static button in footer */}
//           <div
//             ref={footerRef}
//             className={`mt-4 flex justify-end items-center transition-opacity duration-300 ${
//               showFloatingButton ? "opacity-50" : "opacity-100"
//             }`}
//           >
//             <button
//               className="w-full max-w-52 bg-[#54B0AF] hover:bg-teal-600 text-[#FFFFFF] rounded-[20px] px-4 py-4 text-sm font-medium md:text-[16px] font-gotham flex items-center justify-center gap-2 transition-colors"
//               onClick={() => {
//                 setNewChapter(true);
//                 // handleNewChapter();
//               }}
//             >
//               <FiEdit className="w-4 h-4 text-[#FFFFFF] text-base" />
//               Start Reflection
//             </button>
//           </div>
//         </div>

//         {/* Floating Start Reflection Button */}
//         {showFloatingButton && (
//           <div className="fixed bottom-8 right-8 z-50 animate-fade-in">
//             <button
//               className="bg-[#54B0AF] hover:bg-teal-600 text-[#FFFFFF] rounded-2xl px-6 py-4 text-sm font-medium md:text-[16px] font-gotham flex items-center justify-center gap-2 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
//               onClick={() => {
//                 setNewChapter(true);
//                 // handleNewChapter();
//               }}
//             >
//               <FiEdit className="w-4 h-4 text-[#FFFFFF]" />
//               Start Reflection
//             </button>
//           </div>
//         )}

//         <PopupModal
//           isOpen={isModalOpen}
//           onClose={handleCloseModal}
//           title={modalTitle}
//           items={modalData}
//           type={modalType}
//         />

//         {/* Add custom CSS for fade-in animation */}
//         <style jsx>{`
//           @keyframes fade-in {
//             from {
//               opacity: 0;
//               transform: translateY(20px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }

//           .animate-fade-in {
//             animation: fade-in 0.3s ease-out;
//           }
//         `}</style>
//         {isLoading && (
//           <div className="fixed inset-0 z-50 bg-white/60 backdrop-blur-sm flex items-center justify-center pointer-events-auto">
//             <div className="flex flex-col items-center justify-center space-y-4">
//               <div className="w-16 h-16 border-4 border-gray-300 border-t-[#54B0AF] rounded-full animate-spin"></div>
//               <span className="text-gray-400 italic text-sm">
//                 {isLoadingData}
//               </span>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default StoryDetails;
